export default {
  accountValidateMsg:
    'アカウントの長さは6-30文字。英数字、記号（＠/_/.)を使用でき、イニシャルは英数字のみです。',
  storeSuccess: 'チャージ成功',
  editAccountTips: '有効なアカウントを入力してください',
  editPwdTips: '有効なパスワードを入力してください',
  editRepeatPwdTips: 'パスワードを再入力してください',
  pwdRepeatTips: '入力パスワードが一致しません',
  changePwdSucc: 'パスワード修正成功',
  bindEmail: 'メールバインド',
  errorVrifyCodeTips: '検証コードエラー',
  slectQuessionTips: 'セキュリティ質問を選択してください',
  answerTips: '解答を入力してください',
  twoAnswerTips: 'セキュリティ質問を二つ選択し、解答してください。',
  realNameValidateTips: '4~60文字の本名を入力してください',
  phoneValidateTips: '6～18桁の電話番号を入力してください',
  areaSelectTips: '正確な国家及び地区を入力してください',
  iDCardValidataTips: '1~60位のマイナンバーを入力してください',
  changeProfileSucc: '編集成功',
  editVrfCodeTips: '検証コードを入力してください',
  securityQuestionTips:
    '安全性向上の為にセキュリティ質問を設定してください。パスワードを忘れた際に、セキュリティ質問を利用して再設定できます。',
  validateQuessionTips:
    '異なる質問を二つ選択し、認証を完了すると、セキュリティ質問を再設定できます。',
  originPwd: '旧パスワードを入力してください',
  newPwd: '新パスワードを入力してください',
  changePwdSuccess:
    'パスワードの修正に成功しました。データ保護の為に、もう一度ログインしてください',
  accountName: 'アカウント名を入力してください',
  password: 'パスワードを入力してください',
  repeatPassword: 'パスワードを再入力してください',
  findPwdTips: 'ご登録済みのアカウントを入力してください',
  submit: '提出',
  send: '送信',
  modify: '修正',
  haveAgree: '同意する',
  and: '及び',
  privacyPolicy: 'プライバシーポリシー',
  completeness: '資料完成度：',
  gender: '性別',
  male: '男',
  female: '女',
  birthday: '生年月日',
  phone: '電話番号',
  region: '国/地区',
  ID: 'パスポートナンバー或いはマイナンバー',
  accountSetting: 'アカウント設定',
  upgrade: 'アカウントランクアップ',
  profile: 'プロフィール',
  changePassword: 'パスワード変更',
  securityQuestion: 'セキュリティ質問',
  creatework_headerTitle: 'オーダー作成',
  mylist_headerTitle: 'マイオーダー',
  bindEmailTips:
    'お使いのメールアドレスを設定し、セキュリティレベルをアップします。パスワードをお忘れの場合、メールアドレスで簡単にパスワードを再設定できます。',
  enterEmailVrfcationTips: '届いた認証コードを入力してください',
  cancel: 'キャンセル',
  bindTps: 'アカウント連携すると複数のデバイスでゲームをプレイできます！',
  login: 'ログイン',
  logout: 'ログアウト',
  bind: 'アカウント連携',
  feedback: 'フィードバック',
  terms: '関連規約',
  tips: 'ヒント',
  debindTips:
    '関連付けを解除するとアカウント情報が消失する恐れがありますが、よろしいですか？',
  debindText: '関連付け解除',
  guestSwitchTips:
    'ログイン後ゲストアカウント情報は消失しますが、よろしいですか？',
  register: '登録',
  realName: '実名',
  enterEmailTips: 'メールアドレスを入力してください',
  emailVAlidateMsg: 'メールアドレスフォーマットエラー',
  editEmaileTips: 'メールアドレスを入力してください',
  checkServiceTips: '利用規約とプライバシーポリシーを閲覧後承認してください！',
  brithdayValidateTips: '正確な誕生日を選択してください',
  facebookValidateTips: '1~60文字のfacebookアカウントを入力してください',
  eritOriginPwdTips: '元のパスワードを入力してください',
  submitSuccess: '申請成功',
  rebindEmail: 'メールアドレス変更',
  bindEmailSuccess:
    'メールアドレス$email</br>と関連付けしました。関連付けされたメールアドレスの認証後、メールアドレスを再設定できます。',
  reSetSecurityQuessoon:
    'セキュリティ質問<br/><br/>を設定しました。それぞれの質問の認証後、質問を再設定できます。',
  canotModifyTips: 'プロフィール情報は提出後変更できませんが、よろしいですか？',
  rebindEmailTips: 'メールアドレス$emailに届いた認証コードを入力してください',
  reGetVrfCode: '認証コード取得',
  findPwdWayTips: '下記の方法で取り戻します',
  emailWay: 'メールアドレスで取り戻します',
  emailWayTips: '届いた認証メールでパスワードを再設定できます。',
  quessionWay: 'セキュリティ質問で取り戻します',
  quessionWayTips: 'セキュリティ質問に解答し、パスワードを再設定できます。',
  resetPwdBtn: 'パスワード再設定',
  lastStep: '前へ',
  sendEmailTips:
    '認証メールアドレス$emailにメールを送信しました。<br>届いた認証コードを正しく入力してください。',
  setNewPwdTips:
    'おめでとうございます！<br>パスワードを再設定できるようになりました。メッセージ欄に新パスワードを入力してください！',
  termsOfUse: '利用規約',
  copy_success: 'コピーしました',
  creatework_create: 'オーダー',
  creatework_createHolder: 'ジャンル選択',
  creatework_title: 'タイトル',
  creatework_titleHolder: 'タイトル入力',
  creatework_detail: 'ご質問の詳細',
  creatework_detailHolder: '200文字以内で入力してください',
  creatework_uploadTips:
    'jpg/pngファイルしかアップできません。ファイルサイズの上限は5MBです',
  creatework_selectBox_selectTile: 'ジャンル',
  creatework_goGame: 'ゲームに戻る',
  creatework_history: 'オーダー履歴',
  mylist_noYet: 'まだ何もありませんよ',
  mywork_solved: '問題解決？クリックしてね',
  mywork_service: '評価',
  mywork_messageHolder: '入力してください',
  mywork_score: '評価してください',
  mywork_confirm: '確認',
  creatework_selectBox_selectList3: 'その他の問題',
  creatework_selectBox_selectList2: 'アカウント問題',
  close: '閉じる',
  creatework_gameHolder: 'ゲームを選択してください',
  creatework_serverHolder: 'サーバーを選択してください',
  contactService: 'お問い合わせ（タップ）',
  FAQ: 'FAQ',
  creatework_game: 'ゲーム：',
  creatework_server: 'サーバー：',
  creatework_role: 'キャラクター：',
  selectRoleName: 'キャラクター選択',
  creatework_noRole: 'キャラクター未作成',
  creatework_noGame: 'ゲームリストに何もありません',
  creatework_noServer: 'サーバーリストに何もありません',
  termText: '{mainHost}のを同意します。',
  backLogin: 'ログインに戻る',
  creatework_roleHolder: 'キャラクターを選択した後、再び訪問してください。',
  findPwdFailTips:
    `セキュリティ質問及びメールバインドを設定していません。global.support@${window.atob('MzdnYW1lcy5jb20=')}にお問い合わせください`,
  payMall: '課金商店',
  selectPayment: '金額選択',
  plzSelectPayWay: '支払方法の選択',
  gainPlus: 'リベート',
  gainMorePlus: 'ハイリベート',
  gainMostPlus: 'MAXリベート',
  plzSelectPayType: '課金方法選択',
  roleName: 'キャラクター名',
  payWay: '支払方法',
  plzSelectOtherWay: '他の支払方法',
  payment: '支払金額',
  compensateTips:
    '商品価値をオーバーする部分は補償として、$gameCodeをお送りします',
  extaGain: '追加獲得',
  gameGold: 'ゲーム内通貨',
  compensate: '補償',
  payWayPlus: 'ルート返金率',
  neddPay: 'お支払い金額',
  submitOrder: 'お支払い',
  screenshotTips:
    'ヒント：オーダー情報をスクリーンショットして保存してください。問題が発生する場合、スクリーンショットを使ってご連絡ください。',
  storeFail: 'チャージを完了できませんでした',
  storeFailTips:
    'チャージ失敗。リトライしてください。ご不明点はカスタマーセンターにお問い合わせください',
  storeAcceptance: '処理中',
  storeSuccessTips: 'お取引後、15分以内にチャージされますので、ご確認ください',
  orderNumber: 'オーダー番号',
  buyProduct: 'アイテム',
  transactionAmount: '取引金額',
  failReason: '失敗原因',
  payOntherORder: '再チャージ',
  reStore: 'リトライ',
  confirm: '確認',
  switch: 'アカウントの切り替え',
  completeTips:
    '個人情報をご記入ください。下記の情報<mark class="yellowMarkColor">をご記入した後、修正できません</mark>。アカウントが紛失したり、盗用されたりする場合、正確な個人資料をご提供いただければ、アカウントを取り戻す事が可能です。',
  creatework_selectBox_selectList0: 'ゲーム問題',
  creatework_selectBox_selectList1: 'お支払いの問題',
  creatework_selectBox_selectList4: '翻訳問題',
  mywork_solvedText: '問題は解決済み',
  browserPayErrBtnText: '取引エラー',
  browserPaySucBtnText: '支払終了',
  browserPayingTips:
    '支払いページへ向かいます。<br/>支払い終了後にこのページを閉じてください。',
  price_list_empty: '選択可能金額がありません',
  pointCardTips: 'ヒント：$paymentAmountでの購入しかサポートできません',
  forgetPwd: 'パスワードを忘れた',
  payCenter: 'チャージセンター',
  willGet: '獲得内容',
  goods: '商品',
  discount: 'おまけ',
  payDiscount: 'オーバー補償',
  payDiscountTips: '商品価格を超えた分の補償です',
  hasQuestionPlease: '質問等ありましたら、',
  pwdValidateMsg: '半角6-20字以内',
  payWayPlusC: 'チャンネルボーナス',
  fwtk: '利用規約',
  yszc: 'プライバシーポリシー',
  exchange: 'ギフトコード交換',
  remember: 'ログインしたままにする',
  thirdInfo: 'アカウント規則',
  thirdInfoContent:
    'ゲーム内のユーザーセンターでアカウントをバンディングしてからログインしてください。',
  unLink: 'サポートされていない方法です',
  favour: 'お気に入り',
  goStoreTip: 'チャージ画面へお進みください',
  go: '進む',
  otherLogin: 'その他の方法',
  qrCodeTip: 'QRコードをスキャンしてください',
  favourTip: 'お気に入りに保存すると、次回スムーズにスタートできます',
  share: 'フレンドにシェア',
  landscapeTip: '画面を縦にして操作してください',
  leaveTip: 'ゲームを終了しますか？',
  selectRole: 'キャラクターを選んでください',
  selectMoney: '購入する道具を選んでください。',
  seletGameInfoFirst: 'ゲームを選んでください',
  lowerIE:
    '申し訳ございません。IE11以下のブラウザには対応しておりません。ブラウザを更新していただくか、下記QRコードよりアプリをダウンロードしてお楽しみください。',
  linkTermText: '{mainHost}の[利用規約]及び[プライバシーポリシー]を同意します',
  download: 'ダウンロード',
  favourAndDownloadTip:
    '旦那様、ブックマーク登録又はダウンロードしてくださいまし(✿◡‿◡)&lt;br/&gt;次回もお会いしとうございます',
  payReward: 'Recharge Reward',
  hasEqualReward: 'Double bonus for both payment methods',
  payBtnText: 'Payment',
  storeHoaveReward: 'Recharge Bonus',
  showMorePayWay: 'More Methods',
  needPaymentCount: 'Amount',
  orderDetail: 'Details',
  selectPayWayPlz: 'Choose payment',
  countryCode: '国番号',
  deleteaccount_title1: 'アカウント削除',
  deleteaccount_title2: '削除申請',
  deleteaccount_step1_1:
    'アカウントの削除を申請すると、14日間アカウントが凍結されます。14日間が過ぎるとアカウントが永久に削除されます。アカウントが削除されてからはSNSなどのコミュニティーへのログインもできなくなります。',
  deleteaccount_step1_2:
    '凍結期間中は以下のリンク先でアカウント削除を取り消すことができます。',
  deleteaccount_step1_3:
    'アカウントが削除されるとすべてのデータがなくなり、二度と復旧できなくなります。',
  deleteaccount_step1_4: 'よろしいでしょうか？',
  deleteaccount_step2_1:
    'アカウントおよびすべてのゲームキャラクターのデータを削除しますか？',
  deleteaccount_step2_2: '「Delete」を入力すると実行されます',
  deleteaccount_step3: 'アカウントの完全なる削除は申請14日後となります。',
  accountrecovery_note: '注意：',
  accountrecovery_tips: 'アカウントの復旧は凍結期間中にしかできません。',
  accountrecovery_Submitted2:
    'アカウントの復旧申請を行いました。アカウントおよびキャラクターの削除申請が取り消されます。',
  accountrecovery_Failed: '申請失敗',
  accountrecovery_Failed_1:
    '対象のアカウントは正常であり、通常通りログインできます。',
  accountrecovery_Failed_2:
    'キャラクターデータが見つかりません。\n再入力してください。',
  accountrecovery_success: 'アカウントが復旧されました',
  account_normal: 'アカウント正常、復旧できません',
  account_unablerestore: 'アカウントなし、復旧できません',
  accountrecovery_roleHolder: 'キャラクターネーム',
  accountrecovery_headerTitle: 'アカウント削除の撤回',
  guideTitle:
    'Your purchase is not successful. Please contact our customer service.',
  accountFix: 'アカウント修復',
  inputAccount: 'Please enter the account name that you wish to recover',
  applyForAccountFix: 'Account Recovery',
  nonEnterItem:
    'Information to add: Registration Date; Model Number; Device Name; Passport or ID Number, Contact E-mail; Please fill in the blanks',
  resetOT: 'Time out, please submit the Review again',
  addOT: 'Time out, please submit the Additional Information again',
  errorPwd:
    'Password has to be 6-20 characters, including letters, numbers, ".", "_", "@"',
  verifyAccount: 'Account info is missing, please check again.',
  selectRegisterTime: 'Please choose your registration time.',
  enterBindEmail: 'Please insert your verified email.',
  enterUsedPhoneType: 'Please insert the model of your mobile phone.',
  enterIdfaGpid: 'Please insert the UDID of your device.',
  enterContactEmail:
    'Incorrect format of Contact E-mail Address; Please re-enter',
  confirmTermsPrivacy:
    'Please read and agree to the service terms and privacy policy.',
  enterRechargeRemark: 'Please insert your recharge record.',
  uploadImg: 'Please upload an Image Scan of your ID, maximum size is 20MB',
  selectIDType: 'Please select the type of your identification document.',
  enterIDNum: 'Please insert your passport number or ID number.',
  enterIP: 'Please insert the IP address you used for registration.',
  enterQueryNum: 'Please enter Review ID',
  enterQueryPwd: 'Please enter Review Password',
  errorQueryItem: 'Incorrect Review ID or Password, please try again',
  enterPassword: 'Please insert a new password.',
  enterPasswordAgain: 'Please confirm your new password.',
  enterPasswordNonSame: 'Inconsistent Password',
  enterEmail: 'Please enter e-mail address',
  sendSuccess: 'E-mail has been sent',
  enterCode: 'Please enter the Verification Code',
  errorCode: 'Incorrect verification code',
  selectQuest: 'Please select a Security Question',
  enterAnswer: 'Please enter the answer',
  selectDifferQuest: 'Please select 3 Security Questions and answers',
  addSuccess: 'Your information has been submitted.',
  picFormt: 'Picture format must be jpg, png or gif',
  countdownBefore: 'Reset Countdown',
  countdownAfter:
    '(The link will expire at 00:00:00, please submit your application again )',
  uploadDone: 'Upload done',
  uploadFail: 'Upload failed',
  applySuccess: 'Application Approved',
  applyFailed: 'Application Denied',
  resetQuestAlterFailed: 'Failed to change security question.',
  resetQuestError: 'Data input error.',
  resetQuestNone: 'Inquiry order not found.',
  resetQuestAltered: 'Security questions have been changed.',
  illegalOperation: 'Illegal Operation',
  queryNotExist: 'Inquiry number does not exist.',
  queryPasswordError: 'Find Password Error',
  auditing: 'Pending approval',
  notPass: 'Denied',
  suppleInformation: 'Submit supplementary information',
  suppleInformationUnHandle:
    'Supplementary information submitted, pending process.',
  suppleInformationTimeout: 'Submit supplementary information timeout.',
  repairedAccountSuccess: 'Account repair has been completed.',
  repairedAccountLost: 'Account repair operation has failed.',
  loginStateNone: 'Not logged in or session has expired.',
  repairedAccountTimeout: 'Account repair duration has expired.',
  changePasswordSucc: 'Password changed.',
  emailSendFailed: 'Failed to send mail.',
  emailSendLimit:
    'The mailbox may not receive any more verification codes today.',
  repairedAccountTimeout2:
    'Illegal operation account repair duration has expired.',
  emailCodeSended: 'E-mail verification code has been sent.',
  alterSuccess: 'Change saved',
  questionAlterSuccess: 'Security question has been changed.',
  username: 'Account name',
  code: 'Please enter the verification code here',
  selectServiceType: 'Please select Service Type',
  submitForm: 'Submit the Form',
  apply: 'Apply',
  reviewApplicationStatus: 'Review Application Status',
  instantReviewOfTheStatus: 'Instant Review of the Status',
  reviewStatus: 'Review Status',
  backToLogin: 'Back to login',
  previous: 'Previous',
  applyDesc:
    'Please enter the information so that we can help. You must fill in the blanks with a * . If such information was missing in your account, please enter "None".',
  additionalServices: 'Additional Services',
  resetSecurityEmail: 'Reset Security E-mail',
  resetSecurityQuest: 'Reset Security Questions',
  registrationDate: 'Registration Date',
  month: 'Month',
  year: 'Year',
  emailBound: 'E-mail Bound',
  modelNumber: 'Mobile model type;',
  deviceName: 'Device Name',
  provideRecharge:
    'Please provide a detailed and complete Recharge Record, including Time, Method, Amount, Order Number, and Transaction ID for us to confirm.',
  selectCountry: 'Region',
  passportID: 'Passport/ ID',
  upload: 'Upload',
  del: 'delete',
  pleaseUpload:
    'Please upload an Image Scan of your ID, with maximum size of 20MB',
  uploadAgain: 'Upload again',
  enterDesc:
    'Please enter any information that proves the ownership of the account',
  contactEmail: 'Contact E-mail',
  applyNoteAttr: 'Note',
  applyNoteDate:
    'please provide your e-mail address so that you can receive the results of your application',
  agree: 'I have agreed to',
  UJOYTerms: 'Terms of Use',
  privacy: 'Privacy Policy',
  reviewStatusOfAccountFix: 'Review Status of Account Fix',
  enterReviewID: 'Please enter Review ID',
  enterReviewPwd: 'Please enter Review Password',
  review: 'Review',
  reviewNoteAttr: 'Note',
  reviewNoteData:
    'Check your Contact E-mail in case you forgot the Review ID and Review Password',
  haveResetInfo: "You've reset your info",
  resetProfile: 'Reset your Profile',
  desc: 'Congrats! Application approved! Please reset your profile.',
  changePwd: 'Change Password',
  resetPwd: 'Reset Password',
  reset: 'Reset',
  enterNewPwd: 'Please enter new password',
  confirmNewPwd: 'Please confirm new password',
  successResetPwd: 'Successfully Reset password',
  bindSecurityEmail: 'Bind Security E-mail',
  resetPwdDesc: 'Reset password when you forgot password or account was stolen',
  bindCommon: 'Bind',
  sendCommon: 'Send',
  enterVcode: 'Please enter the Verification Code',
  successResetEmail: 'Successfully Reset Security E-mail',
  resetQuest: 'Reset Security Questions',
  resetQuestDesc:
    'Reset password when you forget your password or you believe your account info was stolen',
  successResetQuest: 'Successfully Reset Security Questions',
  hide: 'Hide',
  addRegisterTime: 'Registration time;',
  modelNum: 'Model Number: IDFA/GPID',
  registrationIP: 'Registration IP;',
  addRechargeRecord: 'Recharge record;',
  serviceReply: 'Reply from Customer Service:',
  addDataLimitTime: 'Date for Adding Addititional Information:',
  addMoreInfo: 'Add More Information',
  applicationSubmit: 'Application submitted',
  underReviewStatus:
    'Your profile is under review, you will get reply in the next working day. Review status:',
  reviewID: 'Review ID',
  reviePwd: 'Review Password',
  enterReviewIDNPwd: 'Enter Review ID and Review Password to check status',
  homepage: 'Homepage',
  checkEmailAttr: 'Note',
  checkEmailData:
    'Check your Contact E-mail in case you forgot your Review ID and Review Password',
  underReview: 'Under Review',
  underReviewReply:
    'Your profile is under review.We will reply as soon as possible. Thank you for your patience!',
  failed: 'Application Failed',
  reason:
    'Reason: ### Therefore, application failed, please provide correct information, our staff will help. Thank you for your cooperation!',
  underReviewAdd:
    'Your profile is under review. Part of the information is missing or inconsistent, please add more information for us to confirm!',
  addInfoRequired: 'Additional Information Required',
  dateForAddInfo: 'Date for Adding Addititional Information:',
  addInfo: 'Additional Information',
  addInfoSubmit:
    'Additional Information has been submitted! Thank you for your patience!',
  hasBeenRepaired: 'Account has been repaired',
  opExpired: 'Account repair operation expired',
  approved: 'Approved',
  haveSubmitted: "You've submitted",
  sessionExpired: "You've not yet logged in or session value has expired",
  submitted: 'Submitted',
  addItemRegisterDate: 'E-mail;',
  addItemDeviceNumber: 'UDID;',
  reasonItemPwd: 'Inconsistent ID Number;',
  addItemIDPhoto: 'ID Photo;',
  idfaTitle: 'How to find your device IDFA or GPID?',
  idfaSubTitle1: 'For ios user—finding your IDFA',
  idfaSubTitle1Desc1: '1.Download the app 【<em>MyIDFA</em>】from App Store',
  idfaSubTitle1Desc2:
    '2.Open this <em>app</em> and you will find your device <em>IDFA</em>.',
  idfaSubTitle2: 'For Android user—finding your GPID',
  idfaSubTitle2Desc1: '1.tab the <em>“settings”</em> button',
  idfaSubTitle2Desc2:
    '2.tab the <em>“Google”</em> icon below the <em>ACCOUNTS</em> page',
  idfaSubTitle2Desc3:
    '3.then tab the <em>“Ads”</em> icon, and you will find your <em>GPID</em>',
  uploadIDCard:
    'Please upload an Image Scan of your ID, with maximum size of 20MB',
  uploadTipsBefore: 'File size must not be greater than',
  uploadTipsAfter: 'M',
  submitError: 'Error caused by missing ID number or wrong account info.',
  applyLimitError: 'Daily application limit exceeded. (3 times each day)',
  applyDisabled: 'You may only submit once every 10 minutes.',
  inputDataError: 'Data is not completed.',
  dataException: 'Data exception',
  picSizeLimit: 'Picture file size must not exceed 5MB',
  picTypeLimit: 'Upload JPG, PNG, GIF files only',
  picNull: 'Picture is empty',
  alteredPassword: 'Password has been changed.',
  inputError: 'Input error.',
  pwdChangefailed: 'Failed to change password.',
  sendEmailCodeDisabled:
    'Verification code can only be sent again after a period of time.',
  alteredEmail: 'E-mail has been changed.',
  inputEmailError: 'E-mail input error',
  operationFailed: 'Operation failed',
  codeNull: 'You have not entered a verification code yet.',
  findPwd: 'パスワードを忘れた場合',
  findAccountAndPwd: 'アカウントを忘れた場合',
  usualDeviceNum: 'Model Number: IDFA/GPID',
  usualPhoneNum: 'Device Name',
  registerTimeError: 'Inconsistent Registration Date;',
  bindEMailError: 'Inconsistent Bound E-mail;',
  rechargeRecordError: 'Inconsistent Recharge Record;',
  registerIPError: 'Inconsistent Registration IP address;',
  deviceNumError: 'Inconsistent IDFA/GPID;',
  deviceModelError: 'Inconsistent Device Model;',
  confirmTerms: 'Please agree to terms of service',
  applyFixAccount:
    '上記の方法で確認できない場合は、<span>アカウントの修復</span>を申請してください',
  findPwdByFixAccount:
    'サポートメールが設定されておりません。アカウント修復よりパスワードの再発行ができます。',
  connectFail: 'Disconnected from Google Services, please try again',
  h5_favour_has_gift:
    'お気に入りの報酬が届きました、メールでお受け取り下さい。',
  h5_favour_get_gift: 'お気に入りに追加すると、報酬がもらえますよ～',
  h5_get_gift_fault:
    '受領失敗、リトライするかカスタマー・サービスよりお問い合わせください。',
  h5_favour_please_select: 'サーバー/キャラを選択してください',
  h5_favour_login_get:
    '報酬が確実に届くように、まずログインしてキャラクターを作成してください～',
  h5_favour_tip: 'どうぞメールでお受け取り下さい～',
  h5_favour_select_serve: 'Please choose server',
  h5_favour_select_role: 'Please choose character',
  store_product_paytype_error:
    '購入できません。別の支払い方法でもう一回購入してください',
  SwitchWithThirdWay: '${type}でサインイン',
  moreGame: 'その他のゲーム',
  serviceTitle: 'カスタマーサービス',
  h5_download_login:
    '報酬が確実に届くように、まずログインしてキャラクターを作成してください～',
  h5_download_tips: 'Please start the game from the client.',
  h5_download_repeat_get:
    'ダウンロードの報酬が届きました、メールでお受け取り下さい。',
  h5_download_succ: 'ダウンロードをすると、報酬がもらえますよ～',
  h5_download_repeat_role: 'キャラがすでに連携されました',
  currentLoginAccount: 'ログインアカウント：',
  fb_canvas_fullscreen: 'fullｽｸﾘｰﾝ',
  fb_canvas_website: 'HP',
  fb_canvas_like_share: 'ｼｪｱ',
  fb_canvas_service: 'CS',
  fb_canvas_login_fail: 'ログイン失敗',
  fb_canvas_pay_return: 'キャンセルしました',
  fb_canvas_root_tip: 'Facebookへのログインを許可してください',
  h5_popup_title: 'お支払い',
  h5_popup_submit: 'お支払い',
  h5_popup_last_used: '前回使用',
  h5_popup_quit_tips: 'お支払をキャンセルしますか？',
  h5_popup_quit_check: 'YES',
  h5_popup_quit_cancel: 'NO',
  h5_popup_currency_sign: '円',
  h5_popup_product_empty: '製品情報はまだ取得されていません。更新してください',
  h5_popup_server_empty: 'サーバーリストはまだありません。更新してください',
  aboutRelevanceAccount: 'アカウントの連携について',
  selectLoginType: 'ログインする方法を選んでください',
  touristDescription:
    '◆ WEBとアプリとの外部サービス認証（Facebook、Twitter、Google Play）の種類が異なることがございます。',
  touristSuggest:
    '◆ 外部サービス認証でアプリと連携できない場合は、引き継ぎコードで連携をお行いください。',
  h5_tourist_remenber: '14日間この選択を記憶する',
  account_czsm1:
    '1、全てのゲームデータが新しい端末に引き継がれます。OSの異なる端末で引き継ぐことも可能です；',
  account_czsm2: '2、引き継ぐ時のパスワードを登録してください。',
  account_czsm3: '3、セキュリティ保護のため、',
  account_wzfdmm: '大文字と小文字を区別して、6-16文字のパスワードをご入力',
  account_qzcsrmm: '再度パスワードをご入力',
  account_fxyjm: '引き継ぎコード発行',
  account_yjmsm1:
    '1、タイトル画面にある「ユーザーセンター」をタップ、「切り替え」のページで引き継ぎを行ってください。',
  account_yjmsm2: '2、引き継ぎナンバーに使用期限はございません。',
  account_yjmsm3:
    '3、引き継ぎコードは一度しか使えません。再度引き継ぐことができます。',
  account_yjmsm4:
    '4、アカウントを保護するため、引き継ぎコードを他人に教えないようにしてください。',
  account_fz: 'コピー',
  account_cxfx: '新規で発行する',
  account_czsm4: 'アカウントを連携',
  account_czsm5: 'してください。',
  account_yjm: '引き継ぎコード',
  account_16wzzj: 'パスワードの長さは6～16文字にする',
  account_qsrzqdyjmhmm: '正しい引き継ぎコードとパスワードを入力してください。',
  account_yj: '引き継ぎ',
  accoun_lcsrdmmbyz: 'パスワードの両回の入力は一致しない',
  deleteaccount_step3_1:
    'から申請を取り消すことができます。申請を取り消しますか？',
  account_syyjm:
    '1. 引き継ぎコードを使ってゲームデータがこの端末に引き継がれます。',
  account_yjmznsyyc:
    '2. 引き継ぎコードは一度しか使えず、再発行することができます。',
  account_sryjm: '引き継ぎコードを入力',
  account_srmm: 'パスワードを入力',
  h5_header_gift: 'ギフト',
  h5_award_popup_type: '報酬',
  h5_award_popup_content: 'アイテム',
  h5_award_popup_code: 'ギフト交換コード',
  h5_favour_gift_name: 'フォローギフト',
  h5_download_gift_name: 'ダウンロードギフト',
  h5_award_popup_exchange_way:
    '交換方法：ゲームのメイン画面の右下→もっと→交換コード',
  h5_succ_get_gift: 'ギフト交換コードを手に入れました',
  h5_exchange_info_title: '交換方法',
  h5_exchange_info_1: '交換方法：ゲームのメイン画面の右下→もっと→交換コード',
  h5_exchange_info_2:
    '一つのアカウントは「ダウンロードギフト」を1回だけ交換できる',
  h5_check_gift: '報酬確認',
  account_delete_scdqzh:
    'アカウント及びゲームデータを削除してもよろしいですか？',
  account_delete_fwq: 'サーバー',
  account_delete_zhm: 'キャラクター',
  account_delete_jshflj: 'キャラクターを忘れた場合',
  account_delete_qzyzmdxx: '大文字と小文字を区別してください',
  account_delete_jtbcysxx:
    'スクリーンショットに保存し、大切に保管してください！！！',
  deleteaccount_step3_2:
    'アカウントが完全に削除された場合、すべてのデータが二度と復旧できなくなります。\n\n申請から14日間以内に',
  h5_guest_login: 'ゲストログイン',
  h5_click_copy: '',
  questionnaire_btn: 'アンケート調査',
  h5_header_store_text: 'チャージ',
  h5_header_home_text: '公式サイト',
  h5_check_gift_list_text: '報酬一覧',
  yourServer: 'ホストサーバー',
  allServer: 'オールサーバー',
  h5_header_screen: '全画面表示',
  h5_verticalTip: 'ランドスケープモードでプレイしてください',
  h5_third_party_login_tips:
    'SNSアカウント(Facebook , Googleアカウントなど)でログインする場合、ゲストログインした後にユーザーセンターにてSNSアカウントと連携することができます。',
  webStoreUidTitle: '',
  webStoreUidTips: '',
  webStoreUidGuide: '',
  webStoreUidInputt: '',
  feedbackTips:
    'フィードバックをタップすると外部のリンクページに移動します。画像をアップロードするには、ストレージのアクセス権限が必要となります',
  recentPlay: '最近の履歴',
  moreGames: 'もっと',
  previousSelect: '前回の選択',
  payAgainBtn: '再購入',
  packageTypeName: 'パック',
  coinTypeName: '購入',
  cardTypeName: '月間パス',
  orderNormal: 'デフォルト',
  orderPriceUp: '価格昇順',
  orderPriceDown: '価格降順',
  returnSelectRole: '戻る',
  jiamaInfo:
    'ボーナス元宝/ダイヤの説明\nボーナス元宝/ダイヤ=購入金額×ゲームの元宝/ダイヤ率×ボーナス倍率\n※注意：ボーナス元宝/ダイヤはゲーム内の購入イベント対象になりません\n※一部のゲームは世界中に発行されているため、購入する場合ドルで計算します。ご質問がありましたら、気軽にお問い合わせください',
  lastSelectTag: '前回の選択',
  onestore_subscribe_manage: 'Manage',
  onestore_subscribe_entrance: 'OneStore Subscription',
  onestore_subscribe_has_expire: 'Expired',
  onestore_subscribe_expire_time: 'Expire on ${month}/${day}/${year}',
  onestore_subscribe_privacy: 'About Subscription and Privacy',
  onestore_subscribe_cancel_subscribe: 'Cancel Subscription',
  onestore_subscribe_info_title: 'Subscription Info',
  onestore_subscribe_option_title: 'Options',
  onestore_subscribe_do_not_subscribe: 'No subscribed items.',
  onestore_subscribe_get_role_fail:
    'Failed to subscribe. Please open this page again in the game.',
  onestore_subscribe_later: 'Later',
  onestore_subscribe_confirm: 'Confirm',
  onestore_subscribe_confirm_cancel: 'Confirm Cancellation',
  onestore_subscribe_popup_tip:
    'If you cancel now, you can still access your subscription until ${month}/${day}/${year}.',
  onestore_subscribe_detail_tip:
    'Subscribed item will be renewed on ${month}/${day}/${year} (Price: ${prices}/month). Subscription can be canceled 1 day before it expires.',
  onestore_subscribe_expired_tip:
    'Please subscribe the expired item from the in-game Mall/Shop',
  onestore_subscribe_goon_sub: 'Renew on ${month}/${day}/${year}',
  onestore_subscribe_has_cancel_tip1:
    'Subscription canceled. You can still access your subscription until ${month}/${day}/${year}.',
  onestore_subscribe_has_cancel_tip2:
    'If you wish to subscribe again. Please do so in the in-game Mall/Shop.',
  onestore_subscribe_cancel_fail:
    'Failed to cancel subscription. Please try again later.',
  onestore_subscribe_cancel_fail_title: 'Cancel Subscription',
  apple_deleteaccount: 'アカウント削除',
  apple_deleteaccount_title: 'アカウント削除の申請',
  apple_deleteaccount_step1_1: '下記の内容を注意深くお読みください。',
  apple_deleteaccount_step1_2:
    'アカウント削除の申請を提出後、アカウントは14日間凍結されます。',
  apple_deleteaccount_step1_3:
    '14日後、アカウント削除の撤回がない場合、アカウントは<span class="highlight">永久的に削除</span>されます。その後は当該アカウントを利用してゲームにログインすることができません。アカウントに関するすべてのデータ情報は削除され、復元できません。',
  apple_deleteaccount_step1_4:
    'SNSアカウントと連携した場合、アカウントを削除する前に、カスタマーサービスに連絡し、連携を解除する必要があります。解除を忘れた方は、アカウント削除後、連携したSNSアカウントでゲームにログインできなくなりますので、予めご了承ください。',
  apple_deleteaccount_step1_5:
    '<span class="highlight">返金をご希望されるコンテンツはアカウントを削除する前にカスタマーサービスにご連絡ください。</span>',
  apple_deleteaccount_step1_6:
    'アカウントが凍結されている期間中に、下記のリンクをタップし、アカウント削除の申請を撤回することができます。リンクをコピーし、保存してください。',
  apple_deleteaccount_step2_1:
    'ゲーム内資産はすでに処理されましたか？処理を完了していない方は、アカウントを削除する前にカスタマーサービスにご連絡ください。',
  apple_deleteaccount_step2_2:
    'アカウントを復元するにはサーバーとキャラクター情報が必要となります。忘れずに保存してください。',
  apple_deleteaccount_step2_3: '「Delete」を入力してください',
  apple_deleteaccount_step3_1:
    'アカウント削除の申請を提出しました。下記のアカウントはブロックされました。',
  apple_deleteaccount_step3_2:
    '凍結されている14日間に、削除を撤回しないと、アカウントは永久的に削除されます。',
  apple_deleteaccount_step3_3:
    'アカウント削除の申請を撤回したい方は、凍結期間中に下記のリンクをタップしてください',
  apple_deleteaccount_step4_1:
    '古いアカウントは削除されました。次回から新しいアカウントでログインしてください',
  apple_deleteaccount_agree: '上記の内容に同意します',
  apple_deleteaccount_server: 'サーバー',
  apple_deleteaccount_roleName: 'キャラクター名',
  copyLink: 'コピー',
  copyTextAndImg: 'コピー、もしくはスクリーンショットで保存してください',
  copyLinkAndRoleInfo: 'コピー',
  hasCopy: 'コピーしました',
  quickcard_tips:
    'クレジットカード情報は暗号化されWorld Payのプロテクトを受けています。この情報は支払い体験の最適化にのみ使用されます。',
  quickcard_use_new_card: '新しいクレジットカード',
  edit: '編集',
  save: '保存',
  quickcard_confirm_delete: '削除確認',
  quickcard_popup_tip:
    '削除したカードを使用したい場合は、新しいクレジットカードから再度追加してください。',
  quickcard_result_tip_one:
    '先ほど支払い画面にてカード番号を保存したように、クレジットカード情報を暗号化して保存いたします (**** **** **** 1234）。',
  quickcard_result_tip_two:
    '暗号化した情報は支払い体験にのみ使用され、次回購入時に再度カード番号を入力する必要はありません。',
  quickcard_learn_more: '詳しい内容》',
  quickcard_info_title: '保存クレデンシャル',
  quickcard_info_tip_one:
    'ユーザーのデータ保護をより安全にするために、Visa及びMastercardは新しい保存クレデンシャル技術を導入し、保存クレデンシャルと関連する取引を標準化しました。',
  quickcard_info_tip_two:
    '弊社Webサイトで商品を購入する時、ユーザーのクレジットカード情報を暗号化し（1234 **** **** 1234）収集します。暗号化されたデータは4年間保存されます。関連内容に変更がある場合は、弊社Webサイトのユーザー規約とプライバシーポリシーを更新します。暗号化されたクレジットカード情報は、支払い体験を最適化するためにのみ使用され、次回購入時にカード番号を入力する必要はありません。',
  search_product: '商品名検索する',
  search_price: '値段検索する',
  price: '値段',
  product_no_found: '条件に一致する商品/値段が見つかりません。',
  price_no_found: '条件に一致する商品/値段が見つかりません。',
  search_no_found: '条件に一致する商品/値段が見つかりません。',
  product: '商品名',
  store_tag_hot: 'HOT',
  store_tag_discount: 'Discount',
  store_tag_double: 'Double',
  store_tag_treble: 'Treble',
  store_tag_sale: 'SALE',
  store_tag_top_seller: 'TOP SELLER',
  store_tag_off_10: '10%OFF',
  store_tag_off_20: '20%OFF',
  store_tag_off_30: '30%OFF',
  store_tag_off_40: '40%OFF',
  store_tag_off_50: '50%OFF',
  store_tag_off_60: '60%OFF',
  store_tag_off_70: '70%OFF',
  store_tag_off_80: '80%OFF',
  store_tag_off_90: '90%OFF',
  store_tag_event: 'Event',
  store_tag_daily: 'Daily',
  store_tag_weekly: 'Weekly',
  store_tag_monthly: 'Monthly',
  subscriptionTypeName: 'subscription',
  useDoubleSend: '使用する パック倍増券?',
  doubleSendInfo:
    '今回の購入にパック倍増券を使用したため、一部分のアイテムを2倍獲得できます。(注意：2倍獲得可能なアイテムはメールの文末で確認できます)',
  storeRoleTitle: 'チャージしたいキャラクターの選択',
  storeSocialLogin: 'SNSアカウントでログイン',
  storeAccountIdLogin: 'アカウントIDでログイン',
  storeInputId: 'アカウントIDを入力',
  storeSearch: '検索',
  storeSelectProductTitle: '購入したいアイテムを選択',
  storeInputNameSearch: 'アイテム名を入力して検索',
  storeInputPriceSearch: '価格を入力して検索',
  storeNoFindProduct: 'アイテムが見つかりません。もう一度検索してください',
  storePriceUp: '安い順',
  storePriceDown: '高い順',
  storeLookDetail: '詳細確認',
  storeChangeProduct: 'アイテム変更',
  storeWelcome: 'ようこそ',
  storeLookMore: 'もっと見る',
  storeHasSelect: '選択中のアイテム',
  storeTotal: '総計',
  storeExtra: 'ボーナス',
  storeProductDetail: 'アイテム情報',
  storeUidGuideStep1: '「設定」-「その他」-「アカウント」をタップしてください',
  storeUidGuideStep2: '「カウントID」を入力するとチャージできます',
  storeSelectAndLook: 'キャラクターを選択するとアイテムを確認できます',
  storeSwitchWay: 'ログイン方式変更',
  type1: 'デイリーBONUS',
  type2: '英雄',
  type3: '戦闘装備',
  type4: '',
  type5: 'チップ',
  type6: 'ミュータント',
  type7: '資源',
  type8: '建造ブースト',
  type9: 'レア商品',
  type10: 'ギルド',
  type11: 'ダイヤ',
  type12: 'モジュール',
  type13: 'キューブ',
  type14: '',
  type15: 'ナノウェポン',
  type16: '究極大賞',
  type17: '',
  type9999: '数量限定',
  type10000: 'ボーナスセンター',
  type10001: 'ホリディイベント',
  typeother: 'その他の商品',
  switchChar: 'キャラクター切り替え',
  howToFindUid: 'アカウントIDの確認方法',
  choosePayWay: '支払方法を選択してください',
  new_apple_deleteaccount_stepsub_title: '定期購入の自動更新解約',
  new_apple_deleteaccount_stepsub_1:
    'お使いのアカウントが定期購入の自動更新を利用していることがシステムにより判明しました。自動更新によるお支払いの発生を防ぐため、定期購入の自動更新を解約してからアカウントを削除してください。',
  new_apple_deleteaccount_stepsub_2: '解約へ',
  new_apple_deleteaccount_stepsub_later: '後で削除',
  new_apple_deleteaccount_stepsub_now: '今すぐ削除',
  new_apple_deleteaccount_title: 'アカウント削除の申請',
  new_apple_deleteaccount_step1_1: '下記の内容を注意深くお読みください。',
  new_apple_deleteaccount_step1_2:
    'アカウント削除の申請を提出後、アカウントは<span class="highlight">永久的に削除</span>されます。その後は当該アカウントを利用してゲームにログインすることができません。アカウントに関するすべてのデータ情報は削除され、復元できません。',
  new_apple_deleteaccount_step1_3:
    'SNSアカウントと連携した場合、アカウントを削除する前に、カスタマーサービスに連絡し、連携を解除する必要があります。解除を忘れた方は、アカウント削除後、連携したSNSアカウントでゲームにログインできなくなりますので、予めご了承ください。',
  new_apple_deleteaccount_step1_4:
    '<span class="highlight">返金をご希望されるコンテンツはアカウントを削除する前にカスタマーサービスにご連絡ください。</span>',
  new_apple_deleteaccount_step2_1:
    'ゲーム内資産はすでに処理されましたか？処理を完了していない方は、アカウントを削除する前にカスタマーサービスにご連絡ください。',
  new_apple_deleteaccount_step2_2:
    '「Delete」を入力してください。申請を提出後、アカウントは永久的に削除されます。',
  new_apple_deleteaccount_step2_3: '「Delete」を入力してください',
  new_apple_deleteaccount_step3_1:
    'アカウント削除の申請を提出しました。下記のアカウントに関するすべてのデータ情報は削除され、復元できません。',
  new_apple_deleteaccount_step3_2:
    '再びゲームにログインしたい場合、新しいアカウントを作成してください。',
  new_apple_deleteaccount_step4_1:
    '古いアカウントは削除されました。次回から新しいアカウントでログインしてください。',
  currencyTypeName: '交換コイン',
  has_select_product: '合計商品数',
  n_product: '${n}点',
  look_detail_product: 'もっと見る',
  limit_buy_product: '${n}点まで購入可能',
  limit_order: '1つの注文につき最大${n}点まで購入できます。',
  limit_order_remove_tip: '注文に限定購入商品が含まれています。削除しますか？',
  paytype_limit:
    '一部の商品には当該支払い方法を利用できません。他の支払い方法を利用する、または単体で購入してください。',
  check_remove_cart: 'カートから削除しますか？',
  remove_cart: '削除',
  confirm_product: '確定',
  select_paytype: '支払い方法を選択',
  cart_is_empty_tip: 'カートに商品はありません',
  thirty_tip: '30分後、商品がまだ届かない場合、お問合せに連絡してください。',
  total_n_product: '合計 ${n}点の商品',
  look_detail_of_cart: '詳細内容を確認',
  order_detail: '購入履歴',
  total_detail: '数量：',
  add_to_cart: 'カートに入れる',
  back_to_select: '再選択',
  fail_and_later: '商品情報エラー。後ほどもう一度試してください。',
  nextStep: '確認',
  pnsGameName: 'パズル＆サバイバル',
  enterOfficial: '公式サイトへ',
  visitorLogin: 'ゲストログイン',
  tokenLogin: '動的トークン',
  fbLogin: 'Facebookログイン',
  googleLogin: 'Googleログイン',
  twitterLogin: 'Twitterログイン',
  vkLogin: 'VKログイン',
  agreementTextStart:
    'ゲームにログインすると、利用規約とプライバシーポリシーに同意したとみなされます。',
  userCenter: 'マイページ',
  welcomeBack: 'お帰りなさい',
  continueGame: 'ゲームを続ける',
  officialPay: '公式チャージセンター',
  changeAccount: 'アカウントの切替え',
  back: '戻る',
  tokenKey: '動的トークン',
  inputUid: 'UIDを入力してください',
  inputToken: '動的トークンを入力してください',
  inputCkCode: '認証コードを入力してください',
  enterGame: 'ログイン',
  tokenTip: '動的トークンでアカウントを守る',
  howToGetToken: '動的トークンの獲得方法',
  getStep1: 'Step1:設定-アカウント-マイページ',
  getStep2: 'Step2:動的トークンをタップ',
  getStep3: 'Step3:コピーしたUIDと動的トークンを入力',
  copy: 'コピー',
  lastRefresh: '更新まであと：',
  second: 's',
  immediatelyRefresh: '今すぐ更新',
  frequently: '操作が頻繁すぎます。後ほどもう一度試してください。',
  loginFail: '認証コードが正しくないため、ログインできません。',
  tokenIntro: '動的トークンについて',
  tokenIntro1:
    '（1）アカウントを保護するため、動的トークンは更新後120秒以内に使用しないと無効になります。',
  tokenIntro2:
    '（2）公式スタッフが動的トークンを要求することは一切ありませんので、動的トークンを他人に漏らさないように注意してください。',
  nextStep1: '確認',
  couponCanUse: 'クーポン使用可能',
  couponCanNotUse: '使用不可クーポン',
  couponHasNoCoupon: 'なし',
  couponUseTip: '*1回の注文につき1枚のみ',
  couponValidTime: '有効期間',
  couponFuilCanUse: '${price} ${currency} 以上購入でご利用いただけます',
  couponNoLimit: '使用制限なし',
  couponAllProductCanUse: '全商品対象',
  couponPartProductCanUse: '一部商品対象',
  couponPartPaytypeCanUse: '一部の支払い方法にのみ適用',
  couponOnlyCoinCanUse: 'ゲーム内通貨商品にのみ適用',
  couponOnlyDiamondCanUse: 'ダイヤ商品にのみ適用',
  couponOnlyPackageCanUse: 'パック商品にのみ適用',
  couponOnlySubCanUse: '月額購入商品にのみ適用',
  couponOnlyDaibiCanUse: 'トークン商品にのみ適用',
  couponMaxDiscount: '最大${price} ${currency} 引き',
  couponHasUsed: '使用済',
  couponReductionType: '条件付き値引券',
  couponDiscountType: '割引券',
  couponUseNow: '今すぐ使う',
  couponHasNoSelect: '未選択のクーポン',
  couponHasSelectQuan: '選択中',
  couponSubmitTip: '*クーポンは注文提出とともに使用されます',
  couponCanUseQuan: 'クーポン使用可能',
  couponOrderTotal: '合計金額',
  couponHasDiscount: '値引金額',
  couponPayTotal: '支払金額',
  couponCancel: 'キャンセル',
  couponConfirm: '確認',
  uidLoginName: '動的トークンログイン',
  uidToken: '動的トークン',
  uidInputUid: 'UIDを入力してください',
  uidInputToken: '動的トークンを入力してください',
  uidInputCode: '認証コードを入力してください',
  uidTipTitle: '動的トークンでアカウントを守る',
  uidTipHowToGet: '動的トークンの獲得方法',
  uidTipStep1: 'Step1:設定-アカウント-マイページ',
  uidTipStep2: 'Step2:動的トークンをタップ',
  uidTipstep3: 'Step3:コピーしたUIDと動的トークンを入力',
  uidTipIntro1:
    '（1）アカウントを保護するため、動的トークンは更新後60秒以内に使用しないと無効になります。',
  uidTipIntro2:
    '（2）公式スタッフが動的トークンを要求することは一切ありませんので、動的トークンを他人に漏らさないように注意してください。',
  couponMyQuan: 'クーポン',
  couponSelectPaytypeTip: '支払い方法を選んでから値引情報を確認可能',
  couponSelectCouponTip: 'クーポンを選んでから値引情報を確認可能',
  couponValidQuanTip: '（使用可能：${num}枚）',
  couponLookCart: 'カート',
  couponUnfoldCart: '閉じる',
  couponCoupon: 'クーポン',
  couponNoUse: '未使用',
  couponSelect: 'クーポン選択',
  couponSureUse: '確定',
  couponReturn: '戻る',
  couponInvalidTime: '有効期限',
  couponBuyNow: '今すぐ購入',
  couponAllType: '全て',
  ztmslgType1: 'デイリーBONUS',
  ztmslgType2: '英雄',
  ztmslgType3: '戦闘装備',
  ztmslgType4: '',
  ztmslgType5: 'チップ',
  ztmslgType6: 'ミュータント',
  ztmslgType7: '資源',
  ztmslgType8: '建造ブースト',
  ztmslgType9: 'レア商品',
  ztmslgType10: 'ギルド',
  ztmslgType11: 'ダイヤ',
  ztmslgType12: 'モジュール',
  ztmslgType13: 'キューブ',
  ztmslgType14: '',
  ztmslgType15: 'ナノウェポン',
  ztmslgType16: '究極大賞',
  ztmslgType17: '結晶核',
  ztmslgType9999: '数量限定',
  ztmslgType10000: 'ボーナスセンター',
  ztmslgType10001: 'ホリディイベント',
  ztmslgTypeother: 'Other',
  antslgType1: 'デイリーセール',
  antslgType2: '特化アリ',
  antslgType3: '装備',
  antslgType5: '遺伝子',
  antslgType6: 'カタツムリ',
  antslgType7: '資源',
  antslgType8: '建設・開発',
  antslgType9: '希少商品',
  antslgType10: 'コロニー',
  antslgType11: 'ダイヤ',
  antslgType12: '細胞',
  antslgType13: 'トーテム',
  antslgType9999: '数量限定特売',
  antslgTypeother: 'other',
  typeall: 'すべての商品',
  vipHead: 'VIPポイント',
  vipHead213: 'プレミアム',
  vipTitle: 'VIPポイントイベント',
  nowLevel: '現在のVIPレベル：',
  myVipScore: '個人ポイント：',
  nextLevelNeed: 'VIP ${level}まであと${num} ポイント',
  ruleTitle: 'イベントルール：',
  ztmslgVipRule1: '1．イベント開始時間：2022年9月22日00:00時（UTC)　',
  ztmslgVipRule2: '2．対象ゲーム：パズル＆サバイバル',
  ztmslgVipRule3:
    '各ボーナスの割引券は1回のみ受け取れます（ウィークリーボーナスを除く）。',
  ztmslgVipRule4:
    '3．ログインボーナス：初めてチャージ画面からログインすると15%OFF割引券を獲得できます。',
  ztmslgVipRule5:
    '4．ポイントイベント：公式チャージ画面でアイテムを購入しポイントを貯め、指定のVIPレベルに達すると初回到達ボーナスとウィークリーボーナスを獲得できます。',
  ztmslgVipRule6:
    '5．通貨ごとのポイント交換率は一番下の参照リンクから確認できます。',
  ztmslgVipRule7:
    '6．注文時に割引券を使用した場合、ポイントは実際の支払金額によって計算されます。',
  ztmslgVipRule8:
    '7．ポイントの有効期限は365日間です。VIPレベルは有効中のポイントに応じて変化します。',
  ztmslgVipRule9:
    '8．指定のVIPレベルに到達すると、初回到達ボーナスとウィークリーボーナスを獲得できます。ウィークリーボーナスは毎週土曜日0時（UTC）にリセットされ再度受け取ることができます。',
  ztmslgVipRule10:
    '9．ウィークリーボーナスはログイン後に受け取れます。未受領の場合でも補填はされません。割引券の内容は今後変更される場合があります。',
  ztmslgVipRule11:
    '10．割引券の通貨はチャージ時に使用した通貨によって変化します。通貨を変更したい場合、お気軽にお問い合わせください。',
  ztmslgVipRule12: '11．割引券の詳細内容は下の表をご覧ください。',
  ztmslgVipRule13:
    '12．イベントの最終解釈権は「パズル＆サバイバル」運営チームに属します。',
  vipLevel: 'VIPレベル',
  vipCondition: 'ポイント条件',
  firstSend: '初回到達',
  weeklySend: 'ウィークリー',
  lastAllCoupon: '前のレベルのボーナス全て',
  besides: '参照リンク',
  couponRatio: '各通貨の交換レート',
  backToPay: '戻る',
  quanGift: '割引ボーナス',
  quanGiftTips: '新しい割引券をお受け取りください～',
  antslgVipRule1:
    '機能の刷新に伴い、従来の「VIPポイント」イベントは間もなく終了いたします。',
  antslgVipRule2:
    '「VIPポイント」イベントで獲得したクーポンはお早めにご利用ください。有効期限切れにご注意ください。',
  antslgVipRule3: '終了日時：2024 年 9 月 28 日 00:00:00(UTC)',
  antslgVipRule4:
    'イベント終了後は、会員センターにてさらに多くの特典をお楽しみいただけます：',
  antslgVipRule5:
    'タスクをクリアしてポイントを獲得し、ポイントを使ってクーポンやゲームアイテムなどのボーナスと交換できます！会員限定特典やポイント抽選などの特別イベントもご用意しております。',
  antslgVipRule6: 'どうぞお楽しみに。',
  dzgVipRule0: '1．イベント開始時間：2022年9月27日00:00時（UTC)　',
  dzgVipRule1: '1．対象ゲーム：${gameName}',
  dzgVipRule2:
    '各ボーナスの割引券は1回のみ受け取れます（ウィークリーボーナスを除く）。',
  dzgVipRule3:
    '2.ログインボーナス：初めてチャージ画面からログインすると15%OFF割引券を獲得できます。',
  dzgVipRule4:
    '3．ポイントイベント：公式チャージ画面でアイテムを購入しポイントを貯め、指定のVIPレベルに達すると初回到達ボーナスとウィークリーボーナスを獲得できます。',
  dzgVipRule5:
    '4．通貨ごとのポイント交換率は一番下の参照リンクから確認できます。',
  dzgVipRule6:
    '5．注文時に割引券を使用した場合、ポイントは実際の支払金額によって計算されます。',
  dzgVipRule7:
    '6．ポイントの有効期限は365日間です。VIPレベルは有効中のポイントに応じて変化します。',
  dzgVipRule8:
    '7．指定のVIPレベルに到達すると、初回到達ボーナスとウィークリーボーナスを獲得できます。ウィークリーボーナスは毎週土曜日0時（UTC）にリセットされ再度受け取ることができます。',
  dzgVipRule9:
    '8．ウィークリーボーナスはログイン後に受け取れます。未受領の場合でも補填はされません。割引券の内容は今後変更される場合があります。',
  dzgVipRule10:
    '9．割引券の通貨はチャージ時に使用した通貨によって変化します。通貨を変更したい場合、お気軽にお問い合わせください。',
  dzgVipRule11: '10．割引券の詳細内容は下の表をご覧ください。',
  dzgVipRule12:
    '11．イベントの最終解釈権は「${gameName}」運営チームに属します。',
  '213dzgVipRule1':
    '機能の刷新に伴い、従来の「VIPポイント」イベントは間もなく終了いたします。',
  '213dzgVipRule2':
    '「VIPポイント」イベントで獲得したクーポンはお早めにご利用ください。有効期限切れにご注意ください。',
  '213dzgVipRule3': '終了日時：2024 年 8 月 19 日 08:00:00(UTC)',
  '213dzgVipRule4':
    'イベント終了後は、会員センターにてさらに多くの特典をお楽しみいただけます：',
  '213dzgVipRule5':
    'タスクをクリアしてポイントを獲得し、ポイントを使ってクーポンやゲームアイテムなどのボーナスと交換できます！会員限定特典やポイント抽選などの特別イベントもご用意しております。',
  '213dzgVipRule6': 'どうぞお楽しみに。',
  getReward: '専用アイコン',
  unbindEntry: 'アカウント連携/連携解除',
  unbindApply: '連携解除',
  unbindConfirmTitle: '連携を解除してもよろしいでしょうか？',
  unbindConfirmTip:
    '連携を解除するとアカウントの関連データが無くなる可能性があります。続行しますか？',
  unbindConfirm: 'はい',
  unbindExit: 'いいえ',
  unbindSucc: '解除成功',
  unbindFail: '解除失敗！お問合せに連絡してください。',
  unbindServiceTitle:
    'お問い合わせに連絡して、連携の解除を申し込んでください。',
  unbindContact: 'お問い合わせ',
  unbindServiceTip:
    '自動解除できません！お問い合わせに連絡して、連携の解除を申し込んでください。',
  antslgType15: '太古の力',
  shareEventTitle: 'フレンド招待で</br>ギフトゲット',
  shareRule: 'イベントルール',
  awardBag: 'バッグ',
  initiatorText: '推薦者',
  inviteeText: '招待者',
  createCode: '招待コードの作成',
  createCodeTip: 'タップで専用招待コードを作成',
  createLinkTip: 'タップで専用招待コードのリンクを作成',
  copyText: 'コピー',
  shareCode: '招待コードのシェア',
  twShare: '',
  fbShare: '',
  dcShare: '',
  seeAward: 'ボーナス確認',
  seeAwardTip:
    '<span class="see-light">「VIPポイント」</span>-<span class="see-light">「マイクーポン」</span>画面で確認し、使用してください',
  inviteReward: '招待ボーナス',
  inviteRewardTip: '各招待者の初回達成時に推薦者がボーナスを獲得',
  overweightReward: '追加ボーナス',
  resetTip: '毎月の最終日00：00にリセット（UTC+0）',
  rewardText1: '招待者合計チャージ金額\n9.99ドル',
  rewardText2: '招待者合計チャージ金額\n49.99ドル',
  rewardText3: '招待者合計チャージ金額\n99.99ドル',
  rewardText4: '5人招待するたびに、\n12%OFFクーポンGET',
  rewardText5: '招待者の合計金額が1000ドルに到達すると、\n15%OFFクーポンGET',
  invitationList: '招待一覧',
  refresh: '更新',
  invitedTotal: '合計招待人数：${total}',
  storedTotal: '合計チャージ金額：${total} USD',
  people: '',
  invitedPeople: '招待者',
  invitedTime: '招待時間',
  got: '達成済み',
  get: '未達成',
  overlay: '重複可',
  couponText: 'クーポン券',
  personalReward: '個人チャージボーナス',
  personalRewardText1: '個人合計チャージ金額\n9.99ドル',
  personalRewardText2: '個人合計チャージ金額\n49.99ドル',
  personalRewardText3: '個人合計チャージ金額\n99.99ドル',
  inputCode: '招待コードを入力',
  bindCode: '確定',
  bindSucc: '確定済み',
  codeTip1: '無効な招待コードです。もう一度やり直してください。',
  codeTip2: '招待コードを使用しました',
  copySucc: 'コピーしました',
  awardName: 'ボーナス',
  getTime: '獲得時間',
  getCondition: '獲得条件',
  couponText1: '6%OFF クーポン',
  couponText2: '8%OFF クーポン',
  couponText3: '10%OFF クーポン',
  couponText4: '12%OFF クーポン',
  couponText5: '15%OFF クーポン',
  ruleText1: '1.イベント時間:2022年11月25日00:00（UTC)',
  ruleText2: '2.対象︰パズル & サバイバル',
  ruleText3:
    '3.「公式チャージシェア』イベント：イベントをシェアし、フレンドを招待しましょう~フレンドが公式チャージ画面で指定金額をチャージするとボーナスを受け取れます',
  ruleText4:
    '4.「第三者支払い月間シェアボーナス」イベント︰月間目標を達成すると対応するボーナスを受け取れます。（ボーナスは毎月更新されます）',
  ruleText5:
    '5.招待した新規プレイヤーが第三者支払い画面で1回以上チャージを行うと、月間ボーナスに加算されます。',
  ruleText6:
    '6.月間ボーナスは毎月の1日に更新されます。更新後、前月の記録はなくなります。',
  ruleText7:
    '7.クーポン券は第三者支払い画面で受け取る必要があります。受領期限が過ぎても補填されません。',
  ruleText8:
    '8.配布されるクーポン券の通貨種類は、最後のチャージ時に使用した通貨種類となります。',
  ruleText9: '9.招待相手が作成した招待コードは使用できません',
  ruleTableTitle1: 'ルール：',
  ruleTableTitle2: 'クーポン券リスト∶',
  ruleTableHead1: 'チャージ条件',
  ruleTableHead2: 'ボーナス条件',
  ruleTableHead3: 'ボーナス',
  ruleTableContent1: '新規プレイヤーを5人招待',
  ruleTableContent2: '新規プレイヤーが1000ドルをチャージ',
  errorTip: '操作失敗',
  eventShareText1: '『パズル&サバイバル』期間限定イベント開催中',
  eventShareText2: '豪華ボーナスが山ほどあるよ',
  cartDoubleTip: '倍増券使用不可',
  codeTip3: '未登録',
  codeTip4: 'パラメータエラー',
  codeTip5: '自分が作成した招待コードを使用できません',
  codeTip6: '招待コードを作成しました',
  payWelfare: 'チャージボーナス',
  wallet: '財布',
  myDiscount: 'マイクーポン',
  knowMore: 'もっと見る',
  backPay: '戻る',
  curBalance: '残高',
  pay: 'チャージ',
  changeCoin: '通貨切替',
  watchDesc: '詳細確認',
  getMore: 'もっと獲得',
  getDiscount: 'クーポン受領',
  notOpenDiscountQuan: 'こうご期待',
  abountZbit: '${Z-BIT}について',
  remain: '残り:',
  payRemain: '支払った後の残高',
  payRemainExpiry: '支払い後残高${money}（有効期限：26年1月1日、お早めにご利用ください）',
  balanceNotEnoughExpiry: '残高不足（26年1月1日失効、チャージ不可）',
  balanceNotEnoggh: '残高が足りません。チャージしてください。',
  goToPay: 'チャージへ',
  chooseOtherPay: '他の支払い方法',
  payIntro: 'チャージ説明',
  logRole: 'ログイン',
  chooseProduct: '商品選択',
  meAgree: '上記の内容に同意します。',
  coinAgreeText:
    '『日替わり内室』運営チームが新たに交換コイン機能を新設しました。ご利用中のアカウントに関連情報を提供する可能性があります。交換コインとは、商品やサービスを購入するために使用するプリペイド機能です。銀行が発行する通貨やその他の支払い手段とは異なります。クレジットカード、プリペイドカード、または『日替わり内室』運営チームが承認するその他決済方法で交換コインを購入することができます。（1回あたりの最大購入金額は運営チームによって決められます）。24時間当たりの使用金額上限（購入金額＋支出金額）は5000ドルまでとなります。ドル以外の通貨を使用する場合は、5000ドル相当の現地通貨金額となります。',
  aboutCoin: '关于交換コイン',
  coinsPayTokenLogin:
    '${Z-BIT}を使用する前に認証コードで認証する必要があります',
  dl3dvnVipRule1: '1.対象ゲーム：${gameName}',
  dl3dvnVipRule2:
    '各ボーナスの割引券は1回のみ受け取れます（ウィークリーボーナスを除く）。',
  dl3dvnVipRule3:
    '2.ログインボーナス：初めてチャージ画面からログインすると15%OFF割引券を獲得できます。',
  dl3dvnVipRule4:
    '3.ポイントイベント：公式チャージ画面でアイテムを購入しポイントを貯め、指定のVIPレベルに達すると初回到達ボーナスとウィークリーボーナスを獲得できます。',
  dl3dvnVipRule5:
    '4.通貨ごとのポイント交換率は一番下の参照リンクから確認できます。',
  dl3dvnVipRule6:
    '5.注文時に割引券を使用した場合、ポイントは実際の支払金額によって計算されます。',
  dl3dvnVipRule7:
    '6.ポイントの有効期限は365日間です。VIPレベルは有効中のポイントに応じて変化します。',
  dl3dvnVipRule8:
    '7.指定のVIPレベルに到達すると、初回到達ボーナスとウィークリーボーナスを獲得できます。ウィークリーボーナスは毎週土曜日0時（UTC）にリセットされ再度受け取ることができます。',
  dl3dvnVipRule9:
    '8.ウィークリーボーナスはログイン後に受け取れます。未受領の場合でも補填はされません。割引券の内容は今後変更される場合があります。',
  dl3dvnVipRule10:
    '9.割引券の通貨はチャージ時に使用した通貨によって変化します。通貨を変更したい場合、お気軽にお問い合わせください。',
  dl3dvnVipRule11: '10.割引券の詳細内容は下の表をご覧ください。',
  dl3dvnVipRule12: '',
  dl3dvnVipRule13:
    '12.イベントの最終解釈権は「${gameName}」運営チームに属します。',
  codeTip7:
    'このプレイヤーはすでにあなたが作成した招待コードを使用したため、再連携できません。',
  ruleText10:
    '10.このイベントの最終解釈権は「パズル&サバイバル」チームに属します。',
  payCoins: 'チャージVIPポイント',
  shareGift: 'シェアでプレゼント',
  attentionCoinUse: '注意：通貨別の残高が通用できません',
  noPayWay:
    '申し訳ございません。選択中の地域には利用可能なサードパーティ決済方法がありません。地域を変更してもう一回お試しください。',
  dl3dtwVipRule1: '1．対象ゲーム：${gameName}',
  dl3dtwVipRule2:
    '各ボーナスの割引券は1回のみ受け取れます（ウィークリーボーナスを除く）。',
  dl3dtwVipRule3:
    '2.ポイントイベント：公式チャージ画面でアイテムを購入しポイントを貯め、指定のVIPレベルに達すると初回到達ボーナスとウィークリーボーナスを獲得できます。',
  dl3dtwVipRule4:
    '3.通貨ごとのポイント交換率は一番下の参照リンクから確認できます。',
  dl3dtwVipRule5:
    '4.注文時に割引券を使用した場合、ポイントは実際の支払金額によって計算されます。',
  dl3dtwVipRule6:
    '5.ポイントの有効期限は365日間です。VIPレベルは有効中のポイントに応じて変化します。',
  dl3dtwVipRule7:
    '6.指定のVIPレベルに到達すると、初回到達ボーナスとウィークリーボーナスを獲得できます。ウィークリーボーナスは毎週土曜日0時（UTC）にリセットされ再度受け取ることができます。',
  dl3dtwVipRule8:
    '7.ウィークリーボーナスはログイン後に受け取れます。未受領の場合でも補填はされません。割引券の内容は今後変更される場合があります。',
  dl3dtwVipRule9:
    '8.割引券の通貨はチャージ時に使用した通貨によって変化します。通貨を変更したい場合、お気軽にお問い合わせください。',
  dl3dtwVipRule10: '9.割引券の詳細内容は下の表をご覧ください。',
  dl3dtwVipRule11:
    '10.イベントの最終解釈権は「${gameName}」運営チームに属します。',
  eventInviteSucc: '招待成功',
  eventGainCondition: '獲得条件',
  eventSuccInvite: 'フレンドを招待しました',
  eventInviteGainOne: '招待者合計チャージ金額\n49.99ドル',
  eventInviteGainTwo: '招待者合計チャージ金額\n99.99ドル',
  eventFriendCode: '所持中の招待コード：',
  eventCheckBind: '連携しますか？',
  eventConfirm: '確定',
  eventCancel: 'キャンセル',
  eventBindSucc: '連携しました！',
  eventGainCoupon: 'クーポン券を手に入れました！',
  eventLookCoupon: 'クーポン券を確認',
  eventSuccBind: '連携しました',
  recaptchaTip: '先に認証してください',
  inputAccountName: '取り戻したいアカウントを入力してください',
  pwaPayTip: 'Topup Centerで楽々チャージ可能',
  pwsInstall: 'デスクトップに追加',
  ztmslgType999: '金券',
  coinUseTips:
    '金券はゲーム内メールで送られます。使用すると、ゲーム内の金券ショップで商品を購入でき、累計チャージボーナスを獲得できます。',
  notice: 'お知らせ',
  popupConfirm: '確定',
  hideWithinWeek: '7日間表示しない',
  ztmslgProductOffTips:
    '最近ユーザーの皆様から支払い画面に関するご意見を沢山いただきました。より良いサービスを提供するために、この度3月13日に予定していた更新を取り消すことになりました。\nいつも応援してくださりありがとうございます。ご不明な点などございましたら、お気軽にお問い合わせください。',
  couponTopLimit: '通貨ごとの割引額上限',
  swsjpVipRule1: '1．イベント開始時間：2023年3月24日00:00時（UTC)',
  swsjpVipRule2: '2．対象ゲーム：${gameName}',
  swsjpVipRule3:
    '各ボーナスの割引券は1回のみ受け取れます（ウィークリーボーナスを除く）。',
  swsjpVipRule4:
    '3．ログインボーナス：初めてチャージ画面からログインすると15%OFF割引券を獲得できます。',
  swsjpVipRule5:
    '4．ポイントイベント：公式チャージ画面でアイテムを購入しポイントを貯め、指定のVIPレベルに達すると初回到達ボーナスとウィークリーボーナスを獲得できます。',
  swsjpVipRule6:
    '5．通貨ごとのポイント交換率は一番下の参照リンクから確認できます。',
  swsjpVipRule7:
    '6．注文時に割引券を使用した場合、ポイントは実際の支払金額によって計算されます。',
  swsjpVipRule8:
    '7．過去のチャージ分は一定の割合に基づき初期ポイントに変換されています。',
  swsjpVipRule9:
    '8．ポイントの有効期限は365日間です。VIPレベルは有効中のポイントに応じて変化します。',
  swsjpVipRule10:
    '9．指定のVIPレベルに到達すると、初回到達ボーナスとウィークリーボーナスを獲得できます。ウィークリーボーナスは毎週土曜日0時（UTC）にリセットされ再度受け取ることができます。',
  swsjpVipRule11:
    '10．ウィークリーボーナスはログイン後に受け取れます。未受領の場合でも補填はされません。割引券の内容は今後変更される場合があります。',
  swsjpVipRule12:
    '11．割引券の通貨はチャージ時に使用した通貨によって変化します。通貨を変更したい場合、お気軽にお問い合わせください。',
  swsjpVipRule13:
    '12．イベントの最終解釈権は「${gameName}」運営チームに属します。',
  beautyVipRule1: '1．イベント開始時間：2023年3月23日00:00時（UTC)',
  beautyVipRule2: '2．対象ゲーム：${gameName}',
  beautyVipRule3:
    '3．ログインボーナス：チャージ画面でログインすると12%OFF割引券を獲得できます。',
  beautyVipRule4:
    '4．ポイントイベント：公式チャージ画面でアイテムを購入しポイントを貯め、指定のVIPレベルに達すると初回到達ボーナスとウィークリーボーナスを獲得できます。',
  beautyVipRule5: '5．割引券の詳細内容は下の表をご覧ください。',
  beautyVipRule6:
    '6.交換比率：1円=1ポイント。購入する時割引券を使用すると、実際の支払金額に基づき累計ポイントが計算されます。',
  beautyVipRule7:
    '7．ポイントの有効期限は365日間です。VIPレベルは有効中のポイントに応じて変化します。',
  beautyVipRule8:
    '8．指定のVIPレベルに到達すると、初回到達ボーナスとウィークリーボーナスを獲得できます。ウィークリーボーナスは毎週土曜日0時にリセットされ再度受け取ることができます。',
  beautyVipRule9:
    '9．ウィークリーボーナスはログイン後に受け取れます。未受領の場合でも補填はされません。割引券の内容は今後変更される場合があります。',
  beautyVipRule10: '10．交換コインで購入する際、割引券を使用できます。',
  beautyVipRule11:
    '11．イベントの最終解釈権は「日替わり内室」運営チームに属します。',
  antslgType999: 'クーポン',
  passAskMods: 'モデレーターに質問',
  passAskModsTip:
    'ゲームに関する問題なら、お気軽にモデレーターに連絡してください。',
  passService: 'お問い合わせ',
  passServiceTip:
    'アカウント、チャージなどについてご不明な点などございましたら、お気軽にお問い合わせに連絡してください。',
  passIKonw: '確定',
  passGoOn: '続ける',
  voucherTitle: '公式チャージセンター',
  voucherAddHome: 'デスクトップに追加',
  voucherAddHomeTipOne: '素早くて、スムーズな支払い体験',
  voucherAddHomeTipTwo: 'ツールバーの「シェア」ボタンをタップして、',
  voucherAddHomeTipThree: '「デスクトップに追加」を選択してください',
  voucherLoginLook: 'ログインしてお得情報を確認',
  voucherSwitchRole: '切り替え',
  voucherCoupon: '割引券',
  voucherVip: 'VIPポイント',
  voucherMoreCoupon: 'お得情報',
  voucherAccountId: 'アカウントID',
  voucherOtp: '動的トークン',
  voucherOtherWayPay: '他の士払い方法',
  voucherOtherLoginWay: '他の方法でログイン',
  voucherCouponActivity: 'お得イベント',
  voucherActivityNotBegin: 'イベント未開放。こうご期待',
  voucherGoCommunity: 'コミュニティでより多くのお得情報を手に入れましょう~',
  voucherValidTime: '有効期限',
  voucherLimitRegion: '${currency}で購入する時のみ使用可能',
  voucherLiuyi:
    '使用可能な割引券がありません。公式サイトでお得情報を手に入れましょう～',
  voucherPay: '預かり証を購入',
  voucherAbout: '預かり証について',
  voucherChooseWay: '支払い方法',
  voucherMoreWay: '他の支払い方法',
  voucherChooseCoupon: '割引券を選択',
  voucherHasChoose: '選択中',
  voucherMoneyInsufficient: '残高不足',
  voucherContact: '残高不足。カスタマーサービスに連絡してください。',
  voucherCouponTotal: '使用可能な割引券数',
  voucherCouponTipGuide: '支払い方法選択後、決算時に割引券を使用できます。',
  voucherPaytypeNotSupport: '選択した支払い方法では割引券を使用できません。',
  voucherTipSideOne:
    '預かり証はゲーム内すべてのパック交換および付加価値サービスの利用に使用できます。（預かり証の交換は対象外）',
  voucherTipSideTwo: '最大15%OFF',
  voucherYue: '残高',
  jpUidLoginName: 'LoginPassログイン',
  jpUidToken: 'LoginPass',
  jpUidInputToken: 'LoginPassを入力してください',
  pnsBook: '世紀末の生存指南',
  vipHeadText: 'おめでとう！VIP専用アイコンフレームの解放しました',
  vipHeadGetText: '今すぐ受領',
  vipHeadGotText: '受領済み',
  vipHeadGetTitle: '確定',
  vipHeadGetTip:
    'アカウントにつき1回のみ受領できます。選択したキャラクターで受領しますか？',
  vipHeadAwardText: 'エースコマンダー（永久）',
  vipHeadGetErrTip1:
    '受領失敗。後でもう一度試すか、お問い合わせに連絡してください',
  cartGuideTipNew: 'さらに購入すると割引券を使用可能',
  newVipTitle: '公式チャージサイトVIP',
  newVipLogin: 'ログイン',
  newVipNowPoint: '現在のポイント：',
  newVipNextLevel: '次のレベルまであと${point} ポイント',
  newVipUpgrade: '今すぐレベルアップ',
  newVipLevel: 'VIP特権',
  newVipTip:
    '割引券は毎週の土曜日UTC 0時に更新されます。公式チャージサイトにログインすると自動的に配布されます。',
  newVipWeekly: '週間報酬',
  newVipReachPoint: '達成条件：',
  newVipRuleInfo: 'ルール：',
  pleaseLang: '言語を選択してください',
  reference: 'オーダー番号',
  saveToNext: '次回の支払いにも使用できるために保存してください',
  cardNum: 'カード番号',
  expireTime: '有効期限',
  CVV: 'セキュリティコード',
  pleaseCard: 'クレジットカードを選択してください',
  howToPay: '支払い方法を選択してください',
  checkCard: 'カード番号を確認してください',
  checkExpiryDate: '有効期限を確認してください',
  checkCVV: 'セキュリティコードを確認してください',
  addCard: '追加',
  delete: '削除',
  deleteCardTips: '保存したクレジットカード情報を削除しますか？',
  confirmDelete: 'はい',
  cancelDelete: 'いいえ',
  checkAllCardMsg:
    'カード番号、有効期限、セキュリティコードを確認してください。',
  leaveCreditPageTips:
    'この画面を離れると、支払いが失敗になります。よろしいでしょうか？',
  sureToLeave: '離れる',
  continueToPay: '続ける',
  pushTest: 'プッシュテスト',
  getNoticication: 'プッシュ通知を受信していませんか？',
  waitCheckResult: 'ただ今原因を調べています。検査結果をお待ちください。',
  hadAbnormal:
    '異常を発見しました。プッシュ通知を受信できない可能性があります。',
  clickIntro: '詳細をタップして解決方法を確認してください。',
  networkCheck: 'ネットワーク環境検査',
  noticeAuthorityCheck: '通知許可検査',
  noticeBtnCheck: '通知設定検査',
  gmsCheck: 'GMS検査',
  batteryCheck: 'バッテリー最適化リスト検査',
  pushServiceCheck: 'プッシュ機能検査',
  reCheck: '再検査',
  noNoticeAuthorityTip:
    'ゲームのプッシュ通知は許可されていません。設定-通知画面からこのゲームの通知を許可してください。',
  noNoticeBtnTip:
    'ゲームのプッシュ通知はオフ状態です。システムの設定画面からオン状態に変更してください。',
  noBatteryTip:
    'ゲームがデバイスのバッテリー最適化リストに登録されたため、ゲームのプッシュ通知を受信できない可能性があります。設定-バッテリー-バッテリーの最適化リストからゲームを削除してください。',
  noPushServiceTip:
    'サーバーに接続できません。「接続」ボタンをタップして再接続してください',
  noNetworkTip:
    'ネットワークエラー。安定したネットワークに接続してからもう一度試してください',
  noGmsTip:
    'このデバイスではGMS機能を利用できないため、プッシュ通知を受信できない可能性があります。デバイスを変更してください。',
  pushConnectFail: 'サーバーに接続できません',
  pushConnectSucc: 'サーバーに接続しました',
  noGetPushTitle:
    'ゲームのプッシュ通知を受信できない場合、以下をお試しください。',
  noGetPushContOne:
    '1．ご利用中のデバイスでゲームを再起動してログインしてください',
  noGetPushContTwo:
    '2．「プッシュテスト」ボタンをタップして、テストを行います。ご利用中のデバイスで通知を受信できるかどうかを確認してください。',
  noGetPushContThree:
    '3．テスト通知を受信できるが、ゲームのプッシュ通知を受信できない場合、ゲーム-設定-通知画面からゲーム内の通知設定状態を確認してください。',
  noGetPushContFour:
    '4．上記のステップ通りに操作してもプッシュ通知を受信できない場合、お問い合わせに連絡してください。',
  getPushSucc: 'テスト通知を受信しました！',
  allCheckSucc: '異常がありませんでした',
  pushCheck: 'プッシュ検査',
  useDirectPay: 'エクスプレス チェックアウトを使用する',
  paypalFraudnetInfo: '支払い情報はペイパルリスク管理システムに保護されます。',
  goToSetting: 'Settings',
  retry: 'リトライ',
  connect: '接続',
  canRebind: '連携解除後、再連携することができます。',
  agreePlatform: '${service}と${privite}に同意します。',
  sendGameNews: '最新ゲーム情報を購読します',
  canNotBindEmail:
    '解除すると、このメールアドレスでゲームにログインできなくなります。',
  canNotBindPhone:
    'You will not be able to use this cellphone number to log in once you have unbound it.',
  canChangeByEmail:
    'メールアドレスを通して他の端末でログインすることができます。',
  canChangeByPhone:
    'You may log in with cellphone number on different devices.',
  loginSucc: 'ログイン成功',
  phoneHadBind: 'The cellphone number has already been bound. Log in with it?',
  emailHadBind:
    'このメールアドレスはすでに連携されています。このメールアドレスでログインしますか？',
  phoneNotBind:
    'The cellphone number has not been bound yet. Create a new account?',
  emailNotBind:
    'このメールアドレスはまだ連携していません。新規登録をしますか？',
  emailAccount: 'メールアドレス',
  phoneAccount: 'Cellphone Account',
  phoneInputError: 'Invalid cellphone number',
  registerNewAccount: '新規登録',
  secureTip: 'チャージ代行とアカウントセキュリティに関するお知らせ',
  toTop: '一番上に置く',
  createNewWork: 'お問合せする',
  serviceEvaluate: '評価',
  emailRemind: 'メール通知',
  isAgreeService: '今回のサービスに満足していますか？',
  thankEvaluateTop: 'ご評価いただきありがとうございます。',
  inputValidEmail: '有効なメールアドレスを入力してください。',
  replyWillRemind:
    '質問に返事がありましたら、お知らせのメールが送信されます。この機能を停止したい方は「メール通信」ボタンをもう一度押してください。',
  isCancelEmailRemind:
    'メール通信機能を停止しますか？停止後、お知らせのメールは届きません。',
  reconfirmEmail: 'メールアドレスを確認してください。',
  confirmCanSubmit: '確認後提出できます。',
  serviceWillReply:
    '質問に返事がありましたら、お知らせのメールが送信されます。',
  cancelEmailRemind: '「メール通信」機能を停止しますか？',
  yes: 'はい',
  no: 'いいえ',
  inputWorkSearch: 'キーワードを入力して探してください',
  loading: '読み込み中',
  loadingError: '読み込み失敗。タップして再読み込みしてください。',
  noMore: 'これ以上の内容はありません',
  cancelToTop: '「一番上に置く」をキャンセル',
  evaluateOne: '非常に不満',
  evaluateTwo: '不満',
  evaluateThree: '普通',
  evaluateFour: '満足',
  evaluateFive: '非常に満足',
  confirmDelWorkTop: '今回のお問い合わせ履歴を削除しますか？',
  reRemindEmail:
    'メールのお知らせ機能を再使用したい方は「メール通信」ボタンをタップしてください。',
  confirmWillReply:
    'この機能を使用すると、質問に返事がありましたら、お知らせのメールが送信されます。',
  thankEvaluateBottom: '皆様の評価によってサービス品質が向上されます！',
  confirmDelWorkBottom: '削除すると返事ができなくなりますよ',
  morePurchaseWay: '他の入金方法',
  purchaseNeed: '購入金額：',
  videoUploadSucc: '動画アップロード成功',
  videoUploadFail: '動画アップロード失敗',
  videoUploadLimit:
    'MP4形式、400Mb以下、長さが2分間未満の動画のみアップロードできます。',
  imageUploadSucc: '画像アップロード成功',
  imageUploadFail: '画像アップロード失敗',
  uploading: 'アップロード中',
  smartOrderCreate: 'クイックチケット',
  smartOrderSearch: '検索',
  smartOrderComing: '乞うご期待',
  smartOrderContactService: 'お問い合わせ',
  smartOrderDetector: 'アシスタント',
  smartOrderDetect: '診断',
  smartOrderDetecting: '診断中',
  smartOrderDetectTip:
    'ゲームをプレイしている途中にエラーが検出されました。診断をタップすると、エラーを特定できます。',
  smartOrderDetectTip2:
    'エラーを特定しました。お問い合わせのチケットを提出して、エラーの修復までしばらくお待ちください。',
  smartOrderSubmit: '提出',
  smartOrderIKnow: '分かった',
  smartOrderConfirm: '確定',
  smartOrderLook: '確認',
  smartOrderIsHelp: 'この記事は役に立ちましたか？',
  smartOrderInputQuestion: '質問を入力してください',
  smartOrderPleaseInpt: '入力してください',
  smartOrderPleaseChoose: '選択してください',
  smartOrderStoreTime: 'チャージ時間',
  smartOrderInputOrder: 'オーダー番号を入力してください。',
  smartOrderInputPrice: 'チャージ金額を入力してください。',
  smartOrderNeedHelp: '助けを求めていますか？',
  smartOrderLookHelpTip: '通常問題の解決方法を確認できます。',
  smartOrderNoResult: '結果が見つかりません。他の捜索内容を入力してください。',
  smartOrderUpdateTime: '最新変更時間',
  smartOrderSelectStoreTime: 'チャージ時間を選択してください。',
  smartOrderAtlestChoose: '最低で1つを入力してください。',
  pwaInstallAward: 'デスクトップに追加',
  getMasonry: 'ダイヤ受領',
  addToDrawerVisit: '簡単にアクセスできるようにデスクトップに追加してね',
  immeAddToGet: '今すぐ追加すると限定報酬を入手可能',
  add: '追加',
  talkNextTime: '今度にする',
  chooseRoleGetGift: '報酬受領',
  getGiftSuccess: '受け取りました。ゲーム内で確認してください。',
  dmaTitle: 'パーソナライズド広告',
  newAdd: '追加',
  smartDelete: '削除',
  wordLengthTip: '(0-600文字)',
  areaLimitSwitchRegion: '地区変更',
  areaLimitCurrentRegionCurrency: '現在の地区と通貨',
  areaLimitRegion: '地区：',
  areaLimitCurrency: '通貨：',
  areaLimitNote: '注意：',
  areaLimitSwitchLimitation: '1つのアカウントにつき1年に地区を1回のみ変更可能',
  areaLimitPostSwitchCoupon:
    '変更後、新しく獲得するクーポンは新しい地区に対応した通貨になります。',
  areaLimitRemainingSwitches: '現在の残り回数：${times}',
  areaLimitNoRemainingSwitches: '残り回数なし',
  areaLimitUnableToSwitchThisYear: '本年中はもう変更できません',
  areaLimitCannotSwitch: '変更不可',
  areaLimitNavigateToSwitch: '変更へ',
  areaLimitConfirmSwitch: '確定',
  areaLimitPreSwitchRegionCurrency: '変更前の地区と通貨',
  areaLimitPostSwitchRegionCurrency: '変更後の地区と通貨',
  areaLimitPostSwitchRestriction:
    '変更すると、本年中は再度変更することができません',
  areaLimitUnusedZBitWarning:
    'まだ使用していないZ-Bitがあります。地区を変更すると引き続きZ-Bitを使用することができなくなります。よろしいでしょうか？',
  areaLimitConfirm: '確定',
  areaLimitCancel: 'キャンセル',
  areaLimitInconsistencyWarning: '訪問地区と支払い地区が一致していません。',
  areaLimitPromptToSwitch: '地区を変更しますか？',
  areaLimitEnterZipCode: '*Please enter your zipcode',
  areaLimitEnterInvalid: 'Zipcode is invalid, please re-enter',
  areaLimitTaxRateTips:
    'Depending on your location, the tax rate may vary, the payment amount shall prevail',
  areaLimitInfoCollect:
    'For information collection protection, please refer to the Privacy Policy',
  getAward: '報酬受領',
  selectProductTitle: '商品を選ぶ',
  hotSuggest: 'おすすめ',
  inputKeywordSearch: 'キーワードで探す',
  lookProductContent: '商品をチェック',
  popupClose: '閉じる',
  productSwitch: '商品を変更',
  confirmBuy: '購入する',
  thinkLater: 'また後で',
  areaLimitConfirmRegion: '地区を確認',
  areaLimitContinuePay: '支払いを続ける',
  areaLimitSwitchLimitationTwice: '1つのアカウントにつき1年に地区を2回変更可能',
  dtmslgVipRule1: '1．対象ゲーム：${gameName}',
  dtmslgVipRule2:
    '各ボーナスの割引券は1回のみ受け取れます（ウィークリーボーナスを除く）。',
  dtmslgVipRule3:
    '2.ポイントイベント：公式チャージ画面でアイテムを購入しポイントを貯め、指定のVIPレベルに達すると初回到達ボーナスとウィークリーボーナスを獲得できます。',
  dtmslgVipRule4:
    '3.通貨ごとのポイント交換率は一番下の参照リンクから確認できます。',
  dtmslgVipRule5:
    '4.注文時に割引券を使用した場合、ポイントは実際の支払金額によって計算されます。',
  dtmslgVipRule6:
    '5.ポイントの有効期限は365日間です。VIPレベルは有効中のポイントに応じて変化します。',
  dtmslgVipRule7:
    '6.指定のVIPレベルに到達すると、初回到達ボーナスとウィークリーボーナスを獲得できます。ウィークリーボーナスは毎週土曜日0時（UTC）にリセットされ再度受け取ることができます。',
  dtmslgVipRule8:
    '7.ウィークリーボーナスはログイン後に受け取れます。未受領の場合でも補填はされません。割引券の内容は今後変更される場合があります。',
  dtmslgVipRule9:
    '8.割引券の通貨はチャージ時に使用した通貨によって変化します。通貨を変更したい場合、お気軽にお問い合わせください。',
  dtmslgVipRule10: '9.割引券の詳細内容は下の表をご覧ください。',
  dtmslgVipRule11:
    '10.イベントの最終解釈権は「${gameName}」運営チームに属します。',
  dtmslgType10010: 'デイリーセール',
  dtmslgType10020: '数量限定',
  dtmslgType10030: 'ヒーロー',
  dtmslgType10040: 'バトル装備',
  dtmslgType10050: 'ルーン',
  dtmslgType10060: 'トーテム',
  dtmslgType10070: 'ホーリーストーン',
  dtmslgType10080: 'ドラゴン',
  dtmslgType10090: 'リソース',
  dtmslgType10100: '建設研究',
  dtmslgType10110: 'レア商品',
  dtmslgType10120: '運命武装',
  dtmslgType10130: 'ダイヤ',
  dtmslgType10140: '割引券',
  dtmslgType2: 'イベントギフト',
  dtmslgType3: 'サービスセンター',
  dtmslgType4: '限定ギフト',
  dtmslgType5: 'メイン画面ギフト',
  dtmslgType20010: 'ブラックフライデーギフト',
  dtmslgType20021: '5日間ギフト',
  dtmslgTypeother: 'Other',
  rightsIntro:
    '機能のリニューアルに伴い、旧「VIPポイント」のイベントは終了いたしました。新たなサービスを体験するために、プレミアムセンターへお越しください。<br/>\nプレミアムセンターにおいて、ご達成の任務によりポイントを獲得し、ポイントを使用してクーポンやゲームアイテムなどの報酬を交換することができます！<br/>\nまた、専用の会員特典やポイント抽選などもありますので、さらなる報酬やイベントをお楽しみにお待ちください。',
  '213RightsIntro':
    '機能の刷新に伴い、従来の「VIP ポイント」イベントは間もなく終了いたします。<br />\n 「VIP ポイント」イベントで獲得したクーポンはお早めにご利用ください。有効期限切れにご注意ください。<br />\n 終了日時：2024 年 8 月 19 日 08:00:00(UTC)<br />\n イベント終了後は、会員センターにてさらに多くの特典をお楽しみいただけます：<br />\n タスクをクリアしてポイントを獲得し、ポイントを使ってクーポンやゲームアイテムなどのボーナスと交換できます！会員限定特典やポイント抽選などの特別イベントもご用意しております。<br />\n どうぞお楽しみに。',
  '263RightsIntro':
    '機能の刷新に伴い、従来の「VIP ポイント」イベントは間もなく終了いたします。<br />\n 「VIP ポイント」イベントで獲得したクーポンはお早めにご利用ください。有効期限切れにご注意ください。<br />\n 終了日時：2024 年 9 月 28 日 00:00:00(UTC)<br />\n イベント終了後は、会員センターにてさらに多くの特典をお楽しみいただけます：<br />\n タスクをクリアしてポイントを獲得し、ポイントを使ってクーポンやゲームアイテムなどのボーナスと交換できます！会員限定特典やポイント抽選などの特別イベントもご用意しております。<br />\n どうぞお楽しみに。',
  goToRights: 'プレミアムメンバーセンターに移動',
  oldVipIntro:
    '旧「VIPポイント」のイベントから獲得されたクーポンは、有効期限を過ぎる前にご利用いただくようお願いいたします。',
  'pwa-20001': 'ログインしてください。',
  'pwa-20002': 'パラメータエラー',
  'pwa-20003': 'キャラクターを連携していません。',
  'pwa-20004':
    'ボーナス配布失敗。もう一度試すか、お問い合わせに連絡してください。',
  'pwa-20005': 'すでにこのパックを受け取りました。',
  'pwa-20100': 'イベントはまだ開放されていません。',
  'pwa-20101': 'イベントが終わりました。',
  'pwa-20102': '受領時間外',
  'pwa-20103': '受領時間が終了しました',
  'pwa-1001': '操作が頻繁すぎます。',
  pwaCommon: '後ほどもう一度試してください。',
  zipCodeSwitchZipCode: 'Switch zipcode',
  zipCodeState: 'state',
  zipCodeRate: 'rate',
  '-': '-',
  officialStore: '公式チャージセンター',
  headerSafeTip: 'ノーリスク 迅速対応',
  safeChecking: '...現在の決済環境を検知しています',
  safeChecked: '安心してご利用いただけます',
  riskChecked: 'リスクがあります。操作にご注意ください',
  footerSafeTitle1: '安全',
  footerSafeTitle2: '便利',
  footerSafeTitle3: '特典',
  footerSafeTitle4: '効率',
  footerSafeContent1: '公式チャージセンター',
  footerSafeContent2: '多くの支払い方法に対応',
  footerSafeContent3: '割引や期間限定特典',
  footerSafeContent4: '遅延なし',
  limitedTimeActivityTitle: '期間限定特典',
  limitedTimeActivityTime: 'イベント期間： ${startDate} - ${endDate}（UTC）',
  limitedTimeActivityTaskProcess: '(現在 ${curPay}/${targetPay})',
  limitedTimeActivityRateTips:
    '（為替レートには変動があります。このページの表示を基準とします）',
  limitedTimeActivityNotAchieve: '未完了',
  limitedTimeActivityClaim: '受取',
  limitedTimeActivityClaimed: '受取済',
  limitedTimeActivityTimeLeft:
    '残り時間: ${days}日 ${hours}:${minutes}:${seconds}',
  limitedTimeActivityRecord: '受取履歴',
  limitedTimeActivityAward: '報酬',
  limitedTimeActivityGotTime: '受取日時',
  limitedTimeActivityGotRole: '受取キャラクター',
  limitedTimeActivityRule: 'イベントルール',
  limitedTimeActivity285Rule1:
    '1.イベント期間:  ${startDate} - ${endDate}（UTC）',
  limitedTimeActivity285Rule2:
    '2.イベント期間中、期間限定クエストをクリアすると報酬を受け取れます。クエストは週間クエストと月間クエストがあります。',
  limitedTimeActivity285Rule3:
    '（1）週間クエスト:各アカウントにつき1回限り、毎週月曜日0時にリセットされます',
  limitedTimeActivity285Rule4:
    '週間ログインクエスト:期間内に公式サイトのチャージページに1回ログインしてください。',
  limitedTimeActivity285Rule5:
    '任意の金額でチャージを1回完了:期間内に公式サイトのチャージページで1回チャージを行ってください。金額は問いません。',
  limitedTimeActivity285Rule6:
    '（2）月間クエスト:各アカウントにつき1回限り、毎月1日0時にリセットされます',
  limitedTimeActivity285Rule7:
    'ログインクエスト:期間内に公式サイトのチャージページに1回ログインしてください。',
  limitedTimeActivity285Rule8:
    '累計チャージクエスト:期間内に公式サイトのチャージページで、クエストの条件を満たす金額まで累計チャージを行うと、1回報酬を受け取れます',
  limitedTimeActivity285Rule9:
    'ご注意:イベント期間が長期に渡るため、為替レートが変動する可能性があります。チャージ金額は表示されている金額をご確認ください。',
  limitedTimeActivity285Rule10:
    '報酬を受け取る前に、まずキャラクターを1人選択してください。受け取った後はゲーム内で報酬をご確認ください。',
  limitedTimeActivityClaimAward: '報酬を受け取る',
  limitedTimeActivityConfirmGot: '受け取る',
  limitedTimeActivityGetSucc: '受け取りました',
  limitedTimeActivityGetFail:
    '受け取れませんでした。しばらくしてから再度お試しいただくか、カスタマーサポートにお問い合わせください。',
  limitedTimeActivityFrequent: '操作が頻繁すぎます。しばらくお待ちください。',
  limitedTimeActivityLoginFirst: 'ログインしてください',
  limitedTimeActivityWrongParam: 'パラメーターエラー',
  limitedTimeActivityOverTips:
    'イベントの期限が切れています。ページを更新してください。',
  preRightsIntro:
    '機能の刷新に伴い、従来の「VIP ポイント」イベントは間もなく終了いたします。<br />終了日時：${offLineDate}<br /> 「VIP ポイント」イベントで獲得したクーポンはお早めにご利用ください。有効期限切れにご注意ください。<br />イベント終了後は、会員センターにてさらに多くの特典をお楽しみいただけます：<br />タスクをクリアしてポイントを獲得し、ポイントを使ってクーポンやゲームアイテムなどのボーナスと交換できます！会員限定特典やポイント抽選などの特別イベントもご用意しております。<br />どうぞお楽しみに。',
  riskTipTitle: '不正行為や詐欺のリスクにご注意ください',
  riskTipContent:
    'プレイヤーの皆様、\n\n現在、一部のプレイヤーがゲーム内で秩序や公平性を乱す不正行為を行っていることが確認されています。よくある例として:\n\n1. 違法な広告の掲載:チャット等で違法なリソース取引や非公式チャージなどの広告を掲載すること。\n2. チートやスクリプトの使用:ゲーム内でチートやスクリプトなどの技術的手段を用いて不正に大量の資源を入手すること。\n3. 不適切な勧誘:チャット中にゲームと無関係な不適切な勧誘を送信し、ゲーム外のチャンネル（LineやDiscordなど）での連絡を誘導すること。\n4. 非公式チャージ:安価なチャージを餌に、プレイヤーを非公式のチャージに誘導すること。\n5. その他の詐欺:運営スタッフになりすますなど。\n\nプレイヤーの皆様には、財産や個人情報を守り、不正や詐欺の情報を信じないようご注意いただきたいと思います。上記の不正行為には多くのリスクが伴い、アカウントの盗用リスクだけでなく、詐欺行為に関与する可能性もあります。これらの不正行為によって生じた損失に対して、当社は一切の補償を行いません。\n\n違反アカウントに対しては、違反の深刻さと影響範囲に応じて、警告、不正利益の没収、一時的または永久的なアカウント停止などの措置を講じます。ゲーム内で不審な行為を見かけた場合は、カスタマーサポートにご連絡いただき、ご報告ください。速やかに確認し、適切な対応を取らせていただきます。皆様のご理解とご協力に感謝致します。',
  linkValid: '該リンクは無効です',
  accountLabel: 'アカウント',
  passwordLabel: 'パスワード',
  confirmPasswordLabel: 'パスワード確認',
  confirmDeleteTitle:
    'ゲームアカウントおよびアカウント内のすべてのキャラクターを削除してもよろしいでしょうか？',
  confirmDeleteYes:
    'はい、ゲームアカウントとアカウント内のすべてのキャラクターの削除します',
  selectGame: 'ゲームを選択してください',
  confirmDeleteNo:
    'いいえ、特定のキャラクターだけを削除し、ゲームアカウントは保持します',
  delTermsTitle: 'アカウント削除の条件および注意事項を慎重にお読みください',
  delCondTitle: '1. アカウント削除条件',
  delCond1:
    '（1） 当該ゲームアカウントおよび所属するゲームキャラクターは、ユーザー様ご本人が登録・使用したものである場合、<span>アカウントにログインしてから申請を行ってください</span>。アカウントにログインできない場合は、まず[アカウント復元]を行ってください。',
  delCond2:
    '（2） 当該ゲームアカウントおよび所属するゲームキャラクターに<span>セキュリティリスクがないこと。</span>。これには、未処理の苦情、通報、調査、仲裁、訴訟などや、被苦情、被通報、被調査、被仲裁、被訴訟などが含まれますが、これらに限定されません。 \n',
  delCond3:
    '（3） 当該ゲームアカウントおよび所属するゲームキャラクターに<span>未完了の支払いがないこと。</span>。これには、未清算の返金、未解約のサブスクリプションなどが含まれますが、これらに限定されません。',
  delNoticeTitle: 'アカウント削除に関する注意事項',
  delNotice1:
    '（1） 削除対象は、このゲームアカウントおよび関連するゲームキャラクターです。<span>削除が完了すると、ログインできなくなり、復元もできません</span>。',
  delNotice2:
    '（2） <span>アカウントおよび関連キャラクターのゲーム内資産を事前に清算してください</span>。これにはゲームアイテム、ゲーム内通貨、ゲーム内サブスクリプションなどが含まれますが、これらに限定されません。削除が完了すると、ゲーム内資産はすべて削除されます。ゲームサービス終了後、削除済みアカウントおよび関連キャラクターに対する返金は行いません。 \n',
  delNotice3:
    '（3） ゲームアカウントおよび関連キャラクター情報が削除されると、そのアカウントに関連する情報も削除または匿名化処理されます。ただし、第三者のソーシャルメディアのログイン情報（Facebookでのログインなど）については、プレイヤー様ご自身で連携を解除し、該当するソーシャルプラットフォームで情報の整理を行ってください。',
  delNotice4:
    '（4） お客様の権利を保護するため、14日間の保留期間（一部地域では現地の法規制に基づく例外あり）、つまりクーリングオフ期間を設けています。この期間中、カスタマーサポートに連絡して削除のキャンセルを申請することができます。',
  delNotice5:
    '（5） アカウント削除の申請が正常に送信されると、直ちにアカウントを凍結します。ただし、データの削除には約1週間かかります。完全に削除された後、すぐにメールでお知らせいたします。',
  delFormConfirm1:
    'アカウント削除の条件と結果について、注意深く読み理解しました。',
  delFormConfirm2:
    '削除を申請するアカウントには、未解決の通報や訴訟はありません。',
  delForm:
    '<a class="account-delete-link" href="javascript:;">『アカウント削除規約』</a>を読んだ上で同意します',
  cannotDeleteMsgTitle: 'アカウント削除ができません。',
  cannotDeleteMsg1:
    '以下の条件を満たしていないため、アカウント削除ができません：',
  cannotDeleteMsg2:
    'システムチェックの結果、未処理のお客様からのご意見がございます。ご意見処理が完了してから再度申請をお願いいたします。',
  cannotDeleteMsg3:
    'システムチェックの結果、未精算の返金がございます。返金を完了させてからアカウント削除の申請をお願いいたします。',
  cannotDeleteMsg4:
    'システムチェックの結果、他のプレイヤーからの苦情や通報が進行中です。苦情処理が完了してから再度申請をお願いいたします。',
  formCompleted: 'チケット記入完了',
  formCheckMsg1:
    'お客様のチケット記入が完了いたしました。カスタマーサポートのスタッフによる審査後、チケットへの回答をお待ちください。',
  formCheckMsg2:
    '<span class="account-delete-link">[マイチケット]</span>からチケットの処理状況をご確認いただけます。',
  delEmailMsg1: '削除完了後、メールでお知らせすることをご希望でしょうか？',
  delEmailMsg2:
    'アカウントの削除には大量のデータ処理が必要なため、完全な削除には約1週間ほどかかります。完全に削除が完了した際、メールでお知らせすることをご希望でしょうか？',
  delEmailMsg3:
    'ご記入いただいたメールアドレスは通知用途のみに使用し、他の目的には使用いたしません。',
  delEmailConfirmYes: 'はい、メールで通知してください',
  delEmailFill: '通知先のメールアドレスをご記入ください',
  delEmailConfirmNo: 'いいえ、メールでの通知は不要です',
  delCoolMsg1: '14日間のクーリングオフ期間を選択されますか？',
  delCoolMsg2:
    'クーリングオフ期間中はアカウントが凍結されますが、いつでも削除の取り消しを申請できます。14日後、取り消しがない場合、アカウントは削除され、復元できなくなります。',
  delCoolMsg3:
    'クーリングオフ期間を希望されない場合、申請完了後すぐにアカウントが削除され、復元できなくなります。',
  delCoolConfirmYes: 'はい、14日間のクーリングオフ期間を希望します',
  delCoolConfirmNo: 'いいえ、今すぐ削除します',
  delSecondCheckMsg1:
    'アカウントの全ての内容を処理し、今すぐアカウントのクーリングオフ期間を実行してもよろしいですか？実行後はアカウントにログインできなくなります',
  delSecondCheckConfirmYes: 'はい、すぐに始めてください',
  delResMsg1:
    'アカウント削除申請が提出されました。以下のアカウントは凍結され、ログインできなくなりました：',
  gameName: 'ゲーム名：',
  gameAccount: 'ゲームアカウント：',
  delResMsg2:
    '<span>上記のアカウント情報をスクリーンショットして保存してください。クーリングオフ期間内にアカウントを復元する必要がある場合、これが唯一の証明となります</span>',
  delResMsg3: 'クーリングオフ期間は14日間です。カウントダウン：',
  delResMsg4:
    'クーリングオフ期間内に削除申請を取り消したい場合は、期間内に下の[カスタマーサポートに連絡]をクリックしてください',
  copyAccountInfo: 'アカウント情報をコピー',
  delResMsg5:
    'アカウント削除のお申し込みが完了し、現在削除処理中のため、このアカウントではログインできなくなりました。',
  delResMsg6:
    'アカウントの削除には大量のデータ処理が必要なため、時間がかかります。アカウントの痕跡がすぐに完全に消えるわけではありませんが、約1週間以内に処理を完了いたします。',
  delResMsg7:
    '以前に通知用メールアドレスをご登録いただいている場合は、指定のアドレスにメールをお送りいたします。',
  delResMsg8:
    '再度ゲームにログインされたい場合は、新しいアカウントを作成してログインしていただけます。',
  appleOption: 'App Store',
  googleOption: 'Google Play',
  otherOption: '他のチャネル',
  itemWrong: 'この項目の入力に誤りがあります。もう一度入力してください。',
  delRegisterTime: '登録日時',
  delDevice: 'よく使用する機種',
  delIp: 'よく使用する IP',
  delHistoryPayChannel: '歴史的なチャージチャネル',
  delHistoryPayOrder: '過去チャージ注文番号',
  delDeleteReason: 'アカウント削除理由',
  delPrevStep: '前へ',
  delNextStep: '次へ',
  delSecondCheckMsg2:
    'アカウントの削除を実行してもよろしいですか（アカウントの全内容の処理を完了した状態であることを確認してください）？実行後はアカウントにログインできなくなります',
  pleaseFillIn: '以下の情報をご記入ください',
  switchNewVersion: '新バージョンに',
  switchNewVersionPlatform: '切り替え',
  updateVersionPopupContent: 'ゲームのパフォーマンスをスムーズにし、今後の新機能をサポートするために、デバイスのシステムをアップグレードすることをお勧めします。これにより、より安定した動作体験と互換性の最適化が可能になります。',
  selectTopupTips:"90%のユーザーが公式チャージセンターを利用",
  chuzhi: "チャージ",
  selectMethods: "支払い方法",
  v3LaunchFromDesktopAndRewardToMailbox: 'デスクトップから起動してください\nキャラクター選択後、報酬はメールに届きます'
};
